import React, { ReactElement, Component, useContext, useEffect, useState, Fragment, useRef, useCallback, useMemo, MutableRefObject } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import "./global.less";
import { http_get, http_request, destroy_worker } from "../../worker/http-func";
import { Col, Row, Collapse, Tabs, Table, Badge, Select, Skeleton, Button, Modal, Tooltip } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { ColumnProps } from "antd/es/table";
import {
  profile_user,
  id_card,
  login,
  kubernetes,
  logging,
  monitoring,
  DB,
  rabbitMQ,
  catalog,
  ensaas,
  Microservices,
  workspace_icon,
  workspace_icon_dark_blue,
  workspace_icon_black_gray,
  cry,
  active_circle,
} from "../../img";
import { NodeContext, nodes_type_item } from "../../contexts/nodes";
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { service_components_type_item, ServiceComponentsContext } from "../../contexts/service-component";
import { LeftMenuTitleContext } from "../../contexts/left-menu-title";
import { ThemeContext } from "../../contexts/theme";
import { LastContext } from "../../contexts/last";
import { UsernameLoginContext } from "../../contexts/username-login";
import BreadCrumbs from "../../components/breadcrumb/breadcrumb";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { item } from "../../contexts/items";
import { namespaces_type_item, NamespaceContext } from "../../contexts/namespaces";
import { ClusterInfoContext, cluster_info_type } from "../../contexts/cluster-info";
import { workspace_info_type } from "../../contexts/workspace-info";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { ClusterInfoDisplayContext } from "../../contexts/cluster_info_display";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import { clusters_type_item, ClusterContext } from "../../contexts/clusters";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { UnitContext } from "../../contexts/unit";
import { TypeNameContext } from "../../contexts/type_name";
import { LangContext } from "../../contexts/lang";
import { TableListModalContext } from "../../components/table-list/table-list";
import TableListModal from "../../components/table-list-modal/table-list-modal";
import { table_list_modal_type, TableListModalTypeContext } from "../../contexts/table_list_modal";
// import DropdownMenuSubscription from "../../components/dropdown-menu-subscription/dropdown-menu-subscription";
import { UserSubscriptionsContext, user_subscription } from "../../contexts/user-subscriptions";
import Cookies from "universal-cookie";
import { useDeepCompareMemo, useDeepCompareEffect } from 'use-deep-compare';

const { Panel } = Collapse;
const { TabPane } = Tabs;
const { Option } = Select;

export interface workspacename {
  name?: string;
  id?: string;
}

interface args {
  args: [string, any, React.Dispatch<React.SetStateAction<any>>, string, number, string, string | undefined, string, string];
  args_2: [
    string,
    any,
    React.Dispatch<React.SetStateAction<any>>,
    string | string[],
    number,
    string | string[] | undefined,
    string | undefined,
    string,
    string,
    object | undefined,
    any[] | undefined,
    boolean | undefined,
    boolean | undefined,
    boolean | undefined,
    string | undefined,
    string | undefined,
    string | undefined,
    string | undefined,
    string | undefined,
    number | undefined,
    boolean | undefined,
    string | undefined,
    string | undefined,
    React.Dispatch<React.SetStateAction<string[] | undefined>> | undefined
  ];
}

export function remove_unit(unit_provide: string, str?: string): number {
  const units: (string | number)[] = ["Pi", 1024 * 1024 * 1024, "Ti", 1024 * 1024, "Gi", 1024, "Mi", 1, "Ki", 1 / 1024];
  // const unit_found = units.findIndex((unit: string | number) => (unit as string) === (str && str.substr(str.length - 2, 2)));
  return str
    ? Number((Number(str) / ((units[units.findIndex((unit: string | number) => (unit as string) === unit_provide) + 1] as number) || 1)).toFixed(2))
    : 0;
}

export function change_unit(mi?: string | number, unit?: string, back_to_Mi?: boolean): number {
  //change unit from Mi to user selected
  if (mi && mi === "*") mi = -1;
  const units: (string | number)[] = ["Pi", 1 / 1024 / 1024 / 1024, "Ti", 1 / 1024 / 1024, "Gi", 1 / 1024, "Mi", 1, "Ki", 1024];
  const unit_found: number = units.findIndex((xx) => xx === unit);
  const transform: any = units[unit_found + 1];
  return mi ? (back_to_Mi ? Number((Number(mi) / transform).toFixed(2)) : mi === -1 ? -1 : Number((Number(mi) * transform).toFixed(2))) : 0;
}

export const get_percent = (used: string, quota: string, unit_provide?: string, is_pod?: boolean): JSX.Element => {
  const is_unlimited: boolean = quota === "*";
  const used_new: number = (unit_provide ? remove_unit(unit_provide, used) : Number(used)) || 0,
    quota_new: number = (unit_provide ? remove_unit(unit_provide, quota) : Number(quota)) || 0;
  const percent: number = used_new / quota_new;
  return (
    <Fragment>
      <div className="font-w-6">{is_unlimited ? "Unlimited" : `${!isNaN(percent) ? (percent * 100).toFixed(2) : 0}%`}</div>
      <div>
        {is_pod ? used_new || 0 : (used_new || 0).toFixed(2)} / {is_unlimited ? "Unlimited" : is_pod ? quota_new || 0 : (quota_new || 0).toFixed(2)}
      </div>
    </Fragment>
  );
};

// ███╗   ███╗ █████╗ ██╗███╗   ██╗
// ████╗ ████║██╔══██╗██║████╗  ██║
// ██╔████╔██║███████║██║██╔██╗ ██║
// ██║╚██╔╝██║██╔══██║██║██║╚██╗██║
// ██║ ╚═╝ ██║██║  ██║██║██║ ╚████║
// ╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝
// 主             程             式

const Global: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  // ██╗   ██╗███████╗███████╗ ██████╗ ██████╗ ███╗   ██╗████████╗███████╗██╗  ██╗████████╗
  // ██║   ██║██╔════╝██╔════╝██╔════╝██╔═══██╗████╗  ██║╚══██╔══╝██╔════╝╚██╗██╔╝╚══██╔══╝
  // ██║   ██║███████╗█████╗  ██║     ██║   ██║██╔██╗ ██║   ██║   █████╗   ╚███╔╝    ██║
  // ██║   ██║╚════██║██╔══╝  ██║     ██║   ██║██║╚██╗██║   ██║   ██╔══╝   ██╔██╗    ██║
  // ╚██████╔╝███████║███████╗╚██████╗╚██████╔╝██║ ╚████║   ██║   ███████╗██╔╝ ██╗   ██║
  //  ╚═════╝ ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝   ╚═╝   ╚══════╝╚═╝  ╚═╝   ╚═╝

  const [workspaces, set_workspaces]: [
      workspaces_type_item[] | undefined,
      React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>
    ] = useContext(WorkspaceContext),
    [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>] = useContext(
      NamespaceContext
    ),
    [nodes, set_nodes]: [nodes_type_item[], React.Dispatch<React.SetStateAction<nodes_type_item[]>>] = useContext(NodeContext),
    [service_components, set_service_components]: [
      service_components_type_item[],
      React.Dispatch<React.SetStateAction<service_components_type_item[]>>
    ] = useContext(ServiceComponentsContext),
    [clusters, set_clusters]: [clusters_type_item[], React.Dispatch<React.SetStateAction<clusters_type_item[]>>] = useContext(ClusterContext),
    [cluster_selected, set_cluster_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(ClusterSelectedContext),
    [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(
      WorkSpaceSelectedContext
    ),
    [namespace_selected, set_namespace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(
      NameSpaceSelectedContext
    ),
    [cluster_info, set_cluster_info]: [cluster_info_type, React.Dispatch<React.SetStateAction<cluster_info_type>>] = useContext(ClusterInfoContext),
    [cluster_info_display, set_cluster_info_display]: [string[] | undefined, React.Dispatch<React.SetStateAction<string[] | undefined>>] = useContext(
      ClusterInfoDisplayContext
    ),
    [user_info, set_user_info]: [IUserInfoType, React.Dispatch<React.SetStateAction<IUserInfoType>>] = useContext(UserInfoContext),
    datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
    last: string = useContext(LastContext)[0],
    theme: string = useContext(ThemeContext)[0],
    unit_provide: string = useContext(UnitContext)[0],
    username_login: string | undefined = useContext(UsernameLoginContext)[0],
    set_left_menu_title: React.Dispatch<React.SetStateAction<string>> = useContext(LeftMenuTitleContext)[1],
    lang: string = useContext(LangContext)[0],
    [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(
      TableListModalTypeContext
    ),
    user_subscriptions: user_subscription[] | undefined = useContext(UserSubscriptionsContext)[0],
    // ██╗   ██╗███████╗███████╗███████╗████████╗ █████╗ ████████╗███████╗
    // ██║   ██║██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
    // ██║   ██║███████╗█████╗  ███████╗   ██║   ███████║   ██║   █████╗
    // ██║   ██║╚════██║██╔══╝  ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
    // ╚██████╔╝███████║███████╗███████║   ██║   ██║  ██║   ██║   ███████╗
    //  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝

    [cluster_info_panel, set_cluster_info_panel]: [JSX.Element[] | undefined, React.Dispatch<React.SetStateAction<JSX.Element[] | undefined>>] = useState(),
    [cluster_status, set_cluster_status]: [JSX.Element[], React.Dispatch<React.SetStateAction<JSX.Element[]>>] = useState([] as JSX.Element[]),
    [node_column, set_node_column]: [
      ColumnProps<nodes_type_item>[] | undefined,
      React.Dispatch<React.SetStateAction<ColumnProps<nodes_type_item>[] | undefined>>
    ] = useState<ColumnProps<nodes_type_item>[]>(),
    [workspace_column, set_workspace_column]: [
      ColumnProps<workspaces_type_item>[] | undefined,
      React.Dispatch<React.SetStateAction<ColumnProps<workspaces_type_item>[] | undefined>>
    ] = useState<ColumnProps<workspaces_type_item>[]>(),
    [order_name, set_order_name]: [string, React.Dispatch<React.SetStateAction<string>>] = useState("memory"),
    [order_desc, set_order_desc]: [string, React.Dispatch<React.SetStateAction<string>>] = useState("descend"),
    [workspaces_list, set_workspaces_list] = useState<any>([]),
    [active_collapse, set_active_collapse] = useState<string[]>(["collapse_title"]),
    [active_content, set_active_content] = useState<boolean>(false),
    [nodes_list, set_nodes_list] = useState<any>([]),
    [norole_modal_visible, set_norole_modal_visible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    [tab_selected, set_tab_selected]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(0),
    [isFirst, set_isFirst]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
    { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
    set_type_name: React.Dispatch<React.SetStateAction<string | undefined>> = useContext(TypeNameContext)[1],
    service_component_imgs = useMemo(
      () => [
        { key: "Kubernetes", img: kubernetes, display: "Kubernetes", opacity: 0 },
        { key: "EnSaaS", img: ensaas, display: "EnSaaS", opacity: 0 },
        { key: "Catalog", img: catalog, display: "Catalog", opacity: 1 },
        { key: "Monitoring", img: monitoring, display: "Monitoring", opacity: 1 },
        { key: "Logging", img: logging, display: "Logging", opacity: 1 },
        { key: "DB", img: DB, display: "Database", opacity: 1 },
        { key: "Iothub", img: rabbitMQ, display: "Iothub", opacity: 0 },
        { key: "Servicemesh", img: Microservices, display: "Microservices", opacity: 1 },
      ],
      []
    ),
    //change collapse arrow effect
    collapse_control: any = useCallback((key: any) => {
      if (key.includes("collapse_content") && !key.includes("arrow_icon")) {
        set_active_collapse(["collapse_title", "collapse_content"]);
        set_active_content(true);
      } else if (key.includes("collapse_content") && key.includes("arrow_icon")) {
        set_active_collapse(["collapse_title"]);
        set_active_content(false);
      }
    }, []),
    info_key = useMemo(
      (): { [key: string]: string } => ({
        workspaceOwner: "workspace",
        namespaceDeveloper: "namespace",
      }),
      []
    ),
    // isFirstRun = useRef(true),//xd wkOwner权限偶发刷新console页面不调api
    change_page = useCallback(
      async (activeKey: string): Promise<void> => {

        const cluster_selected_name: string | undefined = cluster_selected?.name;
        if (cluster_selected_name && datacenter_name) {
          let args_each: args["args"] = ([] as unknown) as args["args"],
            // info_each: string = '',
            key_each: string = "";
          const is_node: boolean = activeKey === "node_usage";
          switch (user_info.role) {
            case "globalAdmin":
            case "datacenterAdmin":
            case "clusterAdmin":
            case "clusterOwner":
              key_each = is_node ? "nodes" : "workspaces";
              args_each = [
                key_each,
                props,
                is_node ? set_nodes : set_workspaces,
                `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/${key_each}`,
                0,
                user_info.role,
                user_info.subscription_id,
                datacenter_name,
                cluster_selected_name,
              ];
              // info_each = 'cluster_info';
              break;
            case "workspaceOwner":
              if (activeKey === "workspace_usage") {
                key_each = `workspaces`;
                args_each = [
                  key_each,
                  props,
                  set_workspaces,
                  `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/${key_each}`,
                  0,
                  user_info.role,
                  user_info.subscription_id,
                  datacenter_name,
                  cluster_selected_name,
                ];
              } else {
                key_each = "namespaces";
                args_each = [
                  key_each,
                  props,
                  set_namespaces,
                  `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/${key_each}`,
                  0,
                  user_info.role,
                  user_info.subscription_id,
                  datacenter_name,
                  cluster_selected_name,
                ];
              }
              // info_each = 'workspace_info';
              break;
            case "namespaceDeveloper":
              key_each = "namespaces";
              args_each = [
                key_each,
                props,
                set_namespaces,
                `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/${key_each}`,
                0,
                user_info.role,
                user_info.subscription_id,
                datacenter_name,
                cluster_selected_name,
              ];
              // info_each = 'namespace_info';
              break;
          }

          const args_all: args["args_2"] = args_each.concat([
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            unit_provide,
            set_cluster_info_display,
          ]) as args["args_2"];

          http_request(...args_all);
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        cluster_selected?.name,
        datacenter_name,
        user_info.role,
        set_cluster_info_display,
        set_namespaces,
        set_nodes,
        set_workspaces,
        user_info.subscription_id,
        unit_provide,
      ]
    );

  useEffect((): void => {
    if (user_info.role === "workspaceOwner" && cluster_selected?.name && workspace_selected?.name && datacenter_name) {
      const url: string = `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspace/${workspace_selected.name}`;
      http_request(
        "namespaces",
        props,
        set_namespaces,
        `${url}/namespaces`,
        0,
        user_info.role,
        user_info.subscription_id,
        datacenter_name,
        cluster_selected.name,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        unit_provide
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspace_selected?.name, set_namespaces, unit_provide]);

  useEffect(
    () => () => {
      destroy_worker();
    },
    []
  );

  useDeepCompareEffect((): void => {
    (async (): Promise<void> => {
      if (user_info.role && user_info.role !== "" && datacenter_name) {
        if (isFirst) set_isFirst(true);
        // if (isFirstRun.current) isFirstRun.current = true;
        const actions: {
          [key: string]: (
            | string
            | React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>
            | React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>
            | React.Dispatch<React.SetStateAction<nodes_type_item[]>>
            | React.Dispatch<React.SetStateAction<service_components_type_item[]>>
            | React.Dispatch<React.SetStateAction<cluster_info_type>>
            | React.Dispatch<React.SetStateAction<clusters_type_item[]>>
          )[];
        } = {
          namespaceDeveloper: ["namespaces", set_namespaces],
          get workspaceOwner() {
            return ["workspaces", set_workspaces, ...this.namespaceDeveloper];
          },
          get globalAdmin_clusterOwner() {
            return [...this.workspaceOwner, "nodes", set_nodes, "service_components", set_service_components];
          },
          get clusterOwner() {
            return ["cluster_info", set_cluster_info, ...this.globalAdmin_clusterOwner];
          },
          get clusterAdmin() {
            return ["clusters", set_clusters, ...this.globalAdmin_clusterOwner];
          },
          get globalAdmin() {
            return [...this.clusterAdmin];
          },
        };

        if (
          // workspaceOwner 和 namespaceDeveloper 一定要等選定cluster後才調用API (不然會404)，因為不會調用 /clusters
          ((user_info.role === "workspaceOwner" || user_info.role === "namespaceDeveloper") && cluster_selected?.name) ||
          // 更高的角色不用，因為會調用 /clusters
          (user_info.role !== "workspaceOwner" && user_info.role !== "namespaceDeveloper")
        ) {
          await http_get(
            `${user_info.role}_console`,
            actions[user_info.role || ""],
            user_info.role,
            user_info.subscription_id,
            datacenter_name,
            sessionStorage.getItem("cluster") || cluster_selected?.name || undefined,
            undefined,
            undefined,
            undefined,
            set_cluster_info_display,
            unit_provide
          );
          if (isFirst) set_isFirst(false);
          // if (isFirstRun.current) isFirstRun.current = false;
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    set_nodes,
    set_workspaces,
    set_service_components,
    set_clusters,
    set_cluster_info,
    set_namespaces,
    user_info.role,
    user_info.subscription_id,
    datacenter_name,
    set_cluster_info_display,
    unit_provide,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cluster_selected?.name,
  ]);

  useEffect((): void => {
    set_left_menu_title("Cluster");
  }, [set_left_menu_title]);

  useEffect(() => {
    if (user_info.role) {
      const init: { [key: string]: number } = {
        globalAdmin: 0,
        datacenterAdmin: 0,
        clusterAdmin: 0,
        clusterOwner: 0,
        workspaceOwner: 1,
        namespaceDeveloper: 2,
      };
      set_tab_selected(init[user_info.role]);
    }
  }, [user_info.role]);

  const usage_arr: MutableRefObject<string[]> = useRef(["node_usage", "workspace_usage", "namespace_usage"]);

  useDeepCompareEffect((): void => {
    ((): void => {
      // if (user_info.role !== "" && cluster_selected?.name && !isFirstRun.current) {
      if (user_info.role !== "" && cluster_selected?.name && !isFirst) {
        const page_arr: { [key: string]: string } = {
          node_usage: "node_usage",
          workspace_usage: "workspace_usage",
          namespace_usage: "namespace_usage",
        };
        change_page(page_arr[usage_arr.current[tab_selected]]);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [cluster_selected?.name, tab_selected, unit_provide, change_page, user_info.role, isFirstRun.current]);
}, [cluster_selected?.name, tab_selected, unit_provide, change_page, user_info.role, isFirst]);

  useEffect((): void => {
    const { name }: item = cluster_selected || (clusters[0] || {}).metadata || {};
    if (user_info.role !== "" && name && cluster_selected && clusters && datacenter_name) {
      http_request(
        "cluster_info",
        props,
        set_cluster_info,
        `/v1/datacenter/${datacenter_name}/cluster/${name}/info`,
        0,
        user_info.role,
        user_info.subscription_id,
        datacenter_name,
        name,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        unit_provide
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected, clusters, user_info.role, user_info.subscription_id, set_cluster_info, datacenter_name, unit_provide]);

  useDeepCompareEffect((): void => {
    if (Array.isArray(nodes) && nodes.length > 0) {
      const datas: any = [...nodes];
      switch (order_name) {
        case "node":
          datas.sort((a: any, b: any) => {
            const num: number = a.metadata.name.localeCompare(b.metadata.name);
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "role":
          datas.sort((a: any, b: any) => {
            const num: number = a.metadata?.role?.role?.localeCompare(b.metadata?.role);
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "cpu":
          datas.sort((a: any, b: any) => {
            let a_req_cpu: number = Number(a.metadata.requestCPU);
            let b_req_cpu: number = Number(b.metadata.requestCPU);
            let a_total_cpu: number = Number(a.metadata.totalCPU);
            let b_total_cpu: number = Number(b.metadata.totalCPU);
            const num: number = a_req_cpu / a_total_cpu - b_req_cpu / b_total_cpu;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "cpuUsage":
          datas.sort((a: any, b: any) => {
            let a_used_cpu: number = Number(a.metadata.usedCPU),
              b_used_cpu: number = Number(b.metadata.usedCPU),
              a_total_cpu: number = Number(a.metadata.totalCPU),
              b_total_cpu: number = Number(b.metadata.totalCPU);

            const num: number =
              a_total_cpu === Infinity && b_total_cpu === Infinity
                ? a_used_cpu - b_used_cpu
                : a_total_cpu !== Infinity && b_total_cpu !== Infinity
                ? (a_total_cpu === 0 && b_total_cpu !== 0) || (a_total_cpu !== 0 && b_total_cpu === 0)
                  ? a_used_cpu - b_used_cpu
                  : a_used_cpu === 0 && b_used_cpu === 0
                  ? a_total_cpu - b_total_cpu
                  : a_used_cpu / a_total_cpu - b_used_cpu / b_total_cpu
                : a_used_cpu === 0 && b_used_cpu === 0
                ? a_total_cpu - b_total_cpu
                : a_used_cpu - b_used_cpu && a_total_cpu - b_total_cpu;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "memoryReq":
          datas.sort((a: any, b: any) => {
            let a_req_memory: number = change_unit(a.metadata.requestMemory, unit_provide, false),
              b_req_memory: number = change_unit(b.metadata.requestMemory, unit_provide, false),
              a_total_memory: number = change_unit(a.metadata.totalMemory, unit_provide, false),
              b_total_memory: number = change_unit(b.metadata.totalMemory, unit_provide, false);
            const num: number = a_req_memory / a_total_memory - b_req_memory / b_total_memory;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "memory":
          datas.sort((a: any, b: any) => {
            let a_used_memory: number = change_unit(a.metadata.usedMemory, unit_provide, false),
              b_used_memory: number = change_unit(b.metadata.usedMemory, unit_provide, false),
              a_total_memory: number = change_unit(a.metadata.totalMemory, unit_provide, false),
              b_total_memory: number = change_unit(b.metadata.totalMemory, unit_provide, false);
            const num: number =
              a_total_memory === Infinity && b_total_memory === Infinity
                ? a_used_memory - b_used_memory
                : a_total_memory !== Infinity && b_total_memory !== Infinity
                ? (a_total_memory === 0 && b_total_memory !== 0) || (a_total_memory !== 0 && b_total_memory === 0)
                  ? a_used_memory - b_used_memory
                  : a_used_memory === 0 && b_used_memory === 0
                  ? a_total_memory - b_total_memory
                  : a_used_memory / a_total_memory - b_used_memory / b_total_memory
                : a_used_memory === 0 && b_used_memory === 0
                ? a_total_memory - b_total_memory
                : a_used_memory - b_used_memory && a_total_memory - b_total_memory;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "rootfs":
          datas.sort((a: any, b: any) => {
            let a_used_rootfs: number = change_unit(a.metadata.usedRootfs, unit_provide, false),
              b_used_rootfs: number = change_unit(b.metadata.usedRootfs, unit_provide, false),
              a_total_rootfs: number = change_unit(a.metadata.totalRootfs, unit_provide, false),
              b_total_rootfs: number = change_unit(b.metadata.totalRootfs, unit_provide, false);
            const num: number =
              a_total_rootfs === Infinity && b_total_rootfs === Infinity
                ? a_used_rootfs - b_used_rootfs
                : a_total_rootfs !== Infinity && b_total_rootfs !== Infinity
                ? (a_total_rootfs === 0 && b_total_rootfs !== 0) || (a_total_rootfs !== 0 && b_total_rootfs === 0)
                  ? a_used_rootfs - b_used_rootfs
                  : a_used_rootfs === 0 && b_used_rootfs === 0
                  ? a_total_rootfs - b_total_rootfs
                  : a_used_rootfs / a_total_rootfs - b_used_rootfs / b_total_rootfs
                : a_used_rootfs === 0 && b_used_rootfs === 0
                ? a_total_rootfs - b_total_rootfs
                : a_used_rootfs - b_used_rootfs && a_total_rootfs - b_total_rootfs;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "gpu":
          datas.sort((a: any, b: any) => {
            let a_used_gpu: number = Number(a.metadata.usedGPU),
              b_used_gpu: number = Number(b.metadata.usedGPU),
              a_total_gpu: number = Number(a.metadata.totalGPU),
              b_total_gpu: number = Number(b.metadata.totalGPU);

            const num: number =
              a_total_gpu === Infinity && b_total_gpu === Infinity
                ? a_used_gpu - b_used_gpu
                : a_total_gpu !== Infinity && b_total_gpu !== Infinity
                  ? (a_total_gpu === 0 && b_total_gpu !== 0) || (a_total_gpu !== 0 && b_total_gpu === 0)
                    ? a_used_gpu - b_used_gpu
                    : a_used_gpu === 0 && b_used_gpu === 0
                      ? a_total_gpu - b_total_gpu
                      : a_used_gpu / a_total_gpu - b_used_gpu / b_total_gpu
                  : a_used_gpu === 0 && b_used_gpu === 0
                    ? a_total_gpu - b_total_gpu
                    : a_used_gpu - b_used_gpu && a_total_gpu - b_total_gpu;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "pod":
          datas.sort((a: any, b: any) => {
            let a_used_pod: number = change_unit(a.metadata.usedPod, unit_provide, false),
              b_used_pod: number = change_unit(b.metadata.usedPod, unit_provide, false),
              a_total_pod: number = change_unit(a.metadata.totalPod, unit_provide, false),
              b_total_pod: number = change_unit(b.metadata.totalPod, unit_provide, false);
            const num: number =
              a_total_pod === Infinity && b_total_pod === Infinity
                ? a_used_pod - b_used_pod
                : a_total_pod !== Infinity && b_total_pod !== Infinity
                ? (a_total_pod === 0 && b_total_pod !== 0) || (a_total_pod !== 0 && b_total_pod === 0)
                  ? a_used_pod - b_used_pod
                  : a_used_pod === 0 && b_used_pod === 0
                  ? a_total_pod - b_total_pod
                  : a_used_pod / a_total_pod - b_used_pod / b_total_pod
                : a_used_pod === 0 && b_used_pod === 0
                ? a_total_pod - b_total_pod
                : a_used_pod - b_used_pod && a_total_pod - b_total_pod;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "pvc":
          datas.sort((a: any, b: any) => {
            let a_used_pvc: number = change_unit(a.metadata.usedDisk, unit_provide, false),
              b_used_pvc: number = change_unit(b.metadata.usedDisk, unit_provide, false),
              a_total_pvc: number = change_unit(a.metadata.totalDisk, unit_provide, false),
              b_total_pvc: number = change_unit(b.metadata.totalDisk, unit_provide, false);
            const num: number =
              a_total_pvc === Infinity && b_total_pvc === Infinity
                ? a_used_pvc - b_used_pvc
                : a_total_pvc !== Infinity && b_total_pvc !== Infinity
                ? (a_total_pvc === 0 && b_total_pvc !== 0) || (a_total_pvc !== 0 && b_total_pvc === 0)
                  ? a_used_pvc - b_used_pvc
                  : a_used_pvc === 0 && b_used_pvc === 0
                  ? a_total_pvc - b_total_pvc
                  : a_used_pvc / a_total_pvc - b_used_pvc / b_total_pvc
                : a_used_pvc === 0 && b_used_pvc === 0
                ? a_total_pvc - b_total_pvc
                : a_used_pvc - b_used_pvc && a_total_pvc - b_total_pvc;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
      }

      set_nodes_list(datas.slice(0, 6));
    }
  }, [nodes, order_name, order_desc, set_nodes_list, unit_provide]);

  useEffect((): void => {
    set_node_column([
      {
        title: "",
        dataIndex: "status",
        width: 0.5,
        render: () => {
          return {
            children: (
              <Tooltip title="Active">
                <img src={active_circle} alt="Active" className="height_16" />
              </Tooltip>
            ),
            props: {
              "data-title": "Status: ",
            },
          };
        },
      },
      {
        title: <FormattedMessage id="node" />,
        dataIndex: "metadata",
        key: "node",
        className: "text-ellipsis font-w-6",
        sorter: true,
        // sorter: (a, b) => a.metadata.name.localeCompare(b.metadata.name),
        render: ({ name }: any) => {
          return {
            children: name,
            props: {
              "data-title": "Name: ",
            },
          };
        },
      },
      {
        title: <FormattedMessage id="role" />,
        dataIndex: "metadata.role",
        key: "role",
        sorter: true,
        // sorter: (a, b) => a.metadata.role.localeCompare(b.metadata.role),
        render: (role: { role?: string; taints?: { effect?: string } }) => {
          return {
            children: (
              <Fragment>
                <div className="font-w-6">{(role || {}).role}</div>
                <div>{role !== "" && (((role || {}).taints || {}).effect || "Scheduled")}</div>
              </Fragment>
            ),
            props: {
              "data-title": "Role: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            CPU (Core)
            <br />
            <span className="font-gray">
              <FormattedMessage id="request_limit" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "cpu",
        className: "text-ellipsis font-w-6",
        // sorter: true,
        // sorter: (a, b) => {
        //     let a_req_cpu: number = Number(a.metadata.requestCPU);
        //     let b_req_cpu: number = Number(b.metadata.requestCPU);
        //     let a_total_cpu: number = Number(a.metadata.totalCPU);
        //     let b_total_cpu: number = Number(b.metadata.totalCPU);
        //     return (a_req_cpu / a_total_cpu) - (b_req_cpu / b_total_cpu);
        // },
        render: (metadata: any) => {
          const cpu: string = metadata.requestCPU;
          const cpu_limit_str: string = metadata.limitCPU;
          const cpu_total_str: string = metadata.totalCPU;
          const cpu_number: number = cpu ? (cpu.indexOf(" ") === -1 ? Number(cpu) : Number(cpu.slice(0, cpu.indexOf(" ")))) : 0;
          const cpu_limit_number: number = cpu_limit_str
            ? cpu_limit_str.indexOf(" ") === -1
              ? Number(cpu_limit_str)
              : Number(cpu_limit_str.slice(0, cpu_limit_str.indexOf(" ")))
            : 0;
          const cpu_total: number = cpu_total_str
            ? cpu_total_str.indexOf(" ") === -1
              ? Number(cpu_total_str)
              : Number(cpu_total_str.slice(0, cpu_total_str.indexOf(" ")))
            : 0;
          return {
            children: (
              <Fragment>
                <div>
                  {cpu_total_str === '*' || cpu === '0' ? '0.00' : cpu_total_str === '0' ? 'Unlimited' : ((cpu_number / cpu_total) * 100).toFixed(2)}% / {cpu_total_str === '*' || cpu_limit_str === '0' ? '0.00' : cpu_total_str === '0' ? 'Unlimited' : ((cpu_limit_number / cpu_total) * 100).toFixed(2)}%
                </div>
                <div>
                  {cpu_number.toFixed(2)} / {cpu_limit_number.toFixed(2)}
                </div>
              </Fragment>
            ),
            props: {
              "data-title": "Request/Limit of CPU: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            CPU (Core)
            <br />
            <span className="font-gray">
              <FormattedMessage id="usage_quota" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "cpuUsage",
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_cpu: number = Number(a.metadata.usedCPU),
        //         b_used_cpu: number = Number(b.metadata.usedCPU),
        //         a_total_cpu: number = Number(a.metadata.totalCPU),
        //         b_total_cpu: number = Number(b.metadata.totalCPU);

        //     return a_total_cpu === Infinity && b_total_cpu === Infinity
        //         ? a_used_cpu - b_used_cpu
        //         : a_total_cpu !== Infinity && b_total_cpu !== Infinity
        //             ? (a_total_cpu === 0 && b_total_cpu !== 0) || (a_total_cpu !== 0 && b_total_cpu === 0)
        //                 ? a_used_cpu - b_used_cpu
        //                 : a_used_cpu === 0 && b_used_cpu === 0
        //                     ? a_total_cpu - b_total_cpu
        //                     : a_used_cpu / a_total_cpu - b_used_cpu / b_total_cpu
        //             : a_used_cpu === 0 && b_used_cpu === 0
        //                 ? a_total_cpu - b_total_cpu
        //                 : a_used_cpu - b_used_cpu && a_total_cpu - b_total_cpu;
        // },
        render: (metadata: nodes_type_item["metadata"]) => {
          return {
            children: metadata && get_percent(metadata.usedCPU, metadata.totalCPU),
            props: {
              "data-title": "CPU: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            <FormattedMessage id="memory" /> ({unit_provide})<br />
            <span className="font-gray">
              <FormattedMessage id="request_limit" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "memoryReq",
        className: "text-ellipsis font-w-6",
        // sorter: true,
        // sorter: (a, b) => {
        //     let a_req_memory: number = change_unit(a.metadata.requestMemory, unit_provide, false),
        //         b_req_memory: number = change_unit(b.metadata.requestMemory, unit_provide, false),
        //         a_total_memory: number = change_unit(a.metadata.totalMemory, unit_provide, false),
        //         b_total_memory: number = change_unit(b.metadata.totalMemory, unit_provide, false);
        //     return (a_req_memory / a_total_memory) - (b_req_memory / b_total_memory);
        // },
        render: (metadata: any) => {
          const memory_str: string = metadata.requestMemory;
          const memory_limit_str: string = metadata.limitMemory;
          const memory_total_str: string = metadata.totalMemory;
          const memory_num: number = memory_str
            ? memory_str.indexOf(" ") === -1
              ? Number(memory_str)
              : Number(memory_str.slice(0, memory_str.indexOf(" ")))
            : 0;
          const memory_limit_num: number = memory_limit_str
            ? memory_limit_str.indexOf(" ") === -1
              ? Number(memory_limit_str)
              : Number(memory_limit_str.slice(0, memory_limit_str.indexOf(" ")))
            : 0;
          const memory_total: number = memory_total_str
            ? memory_total_str.indexOf(" ") === -1
              ? Number(memory_total_str)
              : Number(memory_total_str.slice(0, memory_total_str.indexOf(" ")))
            : 0;
          return {
            children: (
              <Fragment>
                <div>
                  {memory_total_str === '*' || memory_str === '0' ? '0.00' : memory_total_str === '0' ? 'Unlimited' : ((memory_num / memory_total) * 100).toFixed(2)}% / {memory_total_str === '*' ||  memory_limit_str === '0' ? '0.00' : memory_total_str === '0' ? 'Unlimited' : ((memory_limit_num / memory_total) * 100).toFixed(2)}%
                </div>
                <div>
                  {change_unit(memory_num, unit_provide, false).toFixed(2)} / {change_unit(memory_limit_num, unit_provide, false).toFixed(2)}
                </div>
              </Fragment>
            ),
            props: {
              "data-title": "Request/Limit of Memory: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            <FormattedMessage id="memory" /> ({unit_provide})<br />
            <span className="font-gray">
              <FormattedMessage id="usage_quota" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "memory",
        className: "text-ellipsis",
        sorter: true,
        defaultSortOrder: "descend",
        // sorter: (a, b) => {
        //     let a_used_memory: number = change_unit(a.metadata.usedMemory, unit_provide, false),
        //         b_used_memory: number = change_unit(b.metadata.usedMemory, unit_provide, false),
        //         a_total_memory: number = change_unit(a.metadata.totalMemory, unit_provide, false),
        //         b_total_memory: number = change_unit(b.metadata.totalMemory, unit_provide, false);
        //     return a_total_memory === Infinity && b_total_memory === Infinity
        //         ? a_used_memory - b_used_memory
        //         : a_total_memory !== Infinity && b_total_memory !== Infinity
        //             ? (a_total_memory === 0 && b_total_memory !== 0) || (a_total_memory !== 0 && b_total_memory === 0)
        //                 ? a_used_memory - b_used_memory
        //                 : a_used_memory === 0 && b_used_memory === 0
        //                     ? a_total_memory - b_total_memory
        //                     : a_used_memory / a_total_memory - b_used_memory / b_total_memory
        //             : a_used_memory === 0 && b_used_memory === 0
        //                 ? a_total_memory - b_total_memory
        //                 : a_used_memory - b_used_memory && a_total_memory - b_total_memory;
        // },
        render: (metadata: nodes_type_item["metadata"]) => {
          return {
            children: metadata && get_percent(metadata.usedMemory, metadata.totalMemory, unit_provide),
            props: {
              "data-title": "Memory: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            <FormattedMessage id="rootfs" /> ({unit_provide})
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "rootfs",
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_rootfs: number = change_unit(a.metadata.usedRootfs, unit_provide, false),
        //         b_used_rootfs: number = change_unit(b.metadata.usedRootfs, unit_provide, false),
        //         a_total_rootfs: number = change_unit(a.metadata.totalRootfs, unit_provide, false),
        //         b_total_rootfs: number = change_unit(b.metadata.totalRootfs, unit_provide, false);
        //     return a_total_rootfs === Infinity && b_total_rootfs === Infinity
        //         ? a_used_rootfs - b_used_rootfs
        //         : a_total_rootfs !== Infinity && b_total_rootfs !== Infinity
        //             ? (a_total_rootfs === 0 && b_total_rootfs !== 0) || (a_total_rootfs !== 0 && b_total_rootfs === 0)
        //                 ? a_used_rootfs - b_used_rootfs
        //                 : a_used_rootfs === 0 && b_used_rootfs === 0
        //                     ? a_total_rootfs - b_total_rootfs
        //                     : a_used_rootfs / a_total_rootfs - b_used_rootfs / b_total_rootfs
        //             : a_used_rootfs === 0 && b_used_rootfs === 0
        //                 ? a_total_rootfs - b_total_rootfs
        //                 : a_used_rootfs - b_used_rootfs && a_total_rootfs - b_total_rootfs;
        // },
        render: (metadata: nodes_type_item["metadata"]) => {
          return {
            children: metadata && get_percent(metadata.usedRootfs, metadata.totalRootfs, unit_provide),
            props: {
              "data-title": "Rootfs: ",
            },
          };
        },
      },
      {
        title: <Fragment>Pod</Fragment>,
        dataIndex: "metadata",
        key: "pod",
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_pod: number = change_unit(a.metadata.usedPod, unit_provide, false),
        //         b_used_pod: number = change_unit(b.metadata.usedPod, unit_provide, false),
        //         a_total_pod: number = change_unit(a.metadata.totalPod, unit_provide, false),
        //         b_total_pod: number = change_unit(b.metadata.totalPod, unit_provide, false);
        //     return a_total_pod === Infinity && b_total_pod === Infinity
        //         ? a_used_pod - b_used_pod
        //         : a_total_pod !== Infinity && b_total_pod !== Infinity
        //             ? (a_total_pod === 0 && b_total_pod !== 0) || (a_total_pod !== 0 && b_total_pod === 0)
        //                 ? a_used_pod - b_used_pod
        //                 : a_used_pod === 0 && b_used_pod === 0
        //                     ? a_total_pod - b_total_pod
        //                     : a_used_pod / a_total_pod - b_used_pod / b_total_pod
        //             : a_used_pod === 0 && b_used_pod === 0
        //                 ? a_total_pod - b_total_pod
        //                 : a_used_pod - b_used_pod && a_total_pod - b_total_pod;
        // },
        render: (metadata: nodes_type_item["metadata"]) => {
          return {
            children: metadata && get_percent(metadata.usedPod, metadata.totalPod, undefined, true),
            props: {
              "data-title": "Pod: ",
            },
          };
        },
      },
      {
        title: <Fragment>GPU</Fragment>,
        dataIndex: "metadata",
        key: "gpu",
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_pod: number = change_unit(a.metadata.usedPod, unit_provide, false),
        //         b_used_pod: number = change_unit(b.metadata.usedPod, unit_provide, false),
        //         a_total_pod: number = change_unit(a.metadata.totalPod, unit_provide, false),
        //         b_total_pod: number = change_unit(b.metadata.totalPod, unit_provide, false);
        //     return a_total_pod === Infinity && b_total_pod === Infinity
        //         ? a_used_pod - b_used_pod
        //         : a_total_pod !== Infinity && b_total_pod !== Infinity
        //             ? (a_total_pod === 0 && b_total_pod !== 0) || (a_total_pod !== 0 && b_total_pod === 0)
        //                 ? a_used_pod - b_used_pod
        //                 : a_used_pod === 0 && b_used_pod === 0
        //                     ? a_total_pod - b_total_pod
        //                     : a_used_pod / a_total_pod - b_used_pod / b_total_pod
        //             : a_used_pod === 0 && b_used_pod === 0
        //                 ? a_total_pod - b_total_pod
        //                 : a_used_pod - b_used_pod && a_total_pod - b_total_pod;
        // },
        render: (metadata: nodes_type_item["metadata"]) => {
          return {
            children: metadata && get_percent(metadata.usedGPU, metadata.totalGPU, undefined, true),
            props: {
              "data-title": "GPU: ",
            },
          };
        },
      },
      {
        title: `${formatMessage({ id: "pvc_disk" })} (${unit_provide})`,
        dataIndex: "metadata",
        key: "pvc",
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_pvc: number = change_unit(a.metadata.usedDisk, unit_provide, false),
        //         b_used_pvc: number = change_unit(b.metadata.usedDisk, unit_provide, false),
        //         a_total_pvc: number = change_unit(a.metadata.totalDisk, unit_provide, false),
        //         b_total_pvc: number = change_unit(b.metadata.totalDisk, unit_provide, false);
        //     return a_total_pvc === Infinity && b_total_pvc === Infinity
        //         ? a_used_pvc - b_used_pvc
        //         : a_total_pvc !== Infinity && b_total_pvc !== Infinity
        //             ? (a_total_pvc === 0 && b_total_pvc !== 0) || (a_total_pvc !== 0 && b_total_pvc === 0)
        //                 ? a_used_pvc - b_used_pvc
        //                 : a_used_pvc === 0 && b_used_pvc === 0
        //                     ? a_total_pvc - b_total_pvc
        //                     : a_used_pvc / a_total_pvc - b_used_pvc / b_total_pvc
        //             : a_used_pvc === 0 && b_used_pvc === 0
        //                 ? a_total_pvc - b_total_pvc
        //                 : a_used_pvc - b_used_pvc && a_total_pvc - b_total_pvc;
        // },
        render: (metadata: nodes_type_item["metadata"]) => {
          return {
            children: metadata && get_percent(metadata.usedDisk, metadata.totalDisk, unit_provide),
            props: {
              "data-title": "PVC Disk: ",
            },
          };
        },
      },
    ]);
  }, [unit_provide, formatMessage]);

  useEffect((): void => {
    if (Array.isArray(workspaces) && workspaces.length > 0) {
      const datas: any = [...workspaces];
      switch (order_name) {
        case "workspace":
          datas.sort((a: any, b: any) => {
            const num: number = a.metadata.labels.name.localeCompare(b.metadata.labels.name);
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "cpuUsage": {
          datas.sort((a: any, b: any) => {
            let a_used_cpu: number = Number(a.metadata.usedCPU);
            let b_used_cpu: number = Number(b.metadata.usedCPU);
            let a_total_cpu: number = a.metadata.totalCPU === "*" ? Infinity : Number(a.metadata.totalCPU);
            let b_total_cpu: number = b.metadata.totalCPU === "*" ? Infinity : Number(b.metadata.totalCPU);
            const num: number =
              a_total_cpu === Infinity && b_total_cpu === Infinity
                ? a_used_cpu - b_used_cpu
                : a_total_cpu !== Infinity && b_total_cpu !== Infinity
                ? (a_total_cpu === 0 && b_total_cpu !== 0) || (a_total_cpu !== 0 && b_total_cpu === 0)
                  ? a_used_cpu - b_used_cpu
                  : a_used_cpu === 0 && b_used_cpu === 0
                  ? a_total_cpu - b_total_cpu
                  : a_used_cpu / a_total_cpu - b_used_cpu / b_total_cpu
                : a_used_cpu === 0 && b_used_cpu === 0
                ? a_total_cpu - b_total_cpu
                : a_used_cpu - b_used_cpu && a_total_cpu - b_total_cpu;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        }
        case "memory":
          datas.sort((a: any, b: any) => {
            let a_used_memory: number = change_unit(a.metadata.usedMemory, unit_provide, false);
            let b_used_memory: number = change_unit(b.metadata.usedMemory, unit_provide, false);
            let a_total_memory: number =
              change_unit(a.metadata.totalMemory, unit_provide, false) === -1 ? Infinity : change_unit(a.metadata.totalMemory, unit_provide, false);
            let b_total_memory: number =
              change_unit(b.metadata.totalMemory, unit_provide, false) === -1 ? Infinity : change_unit(b.metadata.totalMemory, unit_provide, false);
            const num: number =
              a_total_memory === Infinity && b_total_memory === Infinity
                ? a_used_memory - b_used_memory
                : a_total_memory !== Infinity && b_total_memory !== Infinity
                ? (a_total_memory === 0 && b_total_memory !== 0) || (a_total_memory !== 0 && b_total_memory === 0)
                  ? a_used_memory - b_used_memory
                  : a_used_memory === 0 && b_used_memory === 0
                  ? a_total_memory - b_total_memory
                  : a_used_memory / a_total_memory - b_used_memory / b_total_memory
                : a_used_memory === 0 && b_used_memory === 0
                ? a_total_memory - b_total_memory
                : a_used_memory - b_used_memory && a_total_memory - b_total_memory;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "rootfs":
          datas.sort((a: any, b: any) => {
            let a_used_rootfs: number = change_unit(a.metadata.usedRootfs, unit_provide, false);
            let b_used_rootfs: number = change_unit(b.metadata.usedRootfs, unit_provide, false);
            let a_total_rootfs: number =
              change_unit(a.metadata.totalRootfs, unit_provide, false) === -1 ? Infinity : change_unit(a.metadata.totalRootfs, unit_provide, false);
            let b_total_rootfs: number =
              change_unit(b.metadata.totalRootfs, unit_provide, false) === -1 ? Infinity : change_unit(b.metadata.totalRootfs, unit_provide, false);
            const num: number =
              a_total_rootfs === Infinity && b_total_rootfs === Infinity
                ? a_used_rootfs - b_used_rootfs
                : a_total_rootfs !== Infinity && b_total_rootfs !== Infinity
                ? (a_total_rootfs === 0 && b_total_rootfs !== 0) || (a_total_rootfs !== 0 && b_total_rootfs === 0)
                  ? a_used_rootfs - b_used_rootfs
                  : a_used_rootfs === 0 && b_used_rootfs === 0
                  ? a_total_rootfs - b_total_rootfs
                  : a_used_rootfs / a_total_rootfs - b_used_rootfs / b_total_rootfs
                : a_used_rootfs === 0 && b_used_rootfs === 0
                ? a_total_rootfs - b_total_rootfs
                : a_used_rootfs - b_used_rootfs && a_total_rootfs - b_total_rootfs;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "gpu":
          datas.sort((a: any, b: any) => {
            let a_used_gpu: number = Number(a.metadata.usedGPU);
            let b_used_gpu: number = Number(b.metadata.usedGPU);
            let a_total_gpu: number = a.metadata.totalGPU === "*" ? Infinity : Number(a.metadata.totalGPU);
            let b_total_gpu: number = b.metadata.totalGPU === "*" ? Infinity : Number(b.metadata.totalGPU);
            const num: number =
              a_total_gpu === Infinity && b_total_gpu === Infinity
                ? a_used_gpu - b_used_gpu
                : a_total_gpu !== Infinity && b_total_gpu !== Infinity
                  ? (a_total_gpu === 0 && b_total_gpu !== 0) || (a_total_gpu !== 0 && b_total_gpu === 0)
                    ? a_used_gpu - b_used_gpu
                    : a_used_gpu === 0 && b_used_gpu === 0
                      ? a_total_gpu - b_total_gpu
                      : a_used_gpu / a_total_gpu - b_used_gpu / b_total_gpu
                  : a_used_gpu === 0 && b_used_gpu === 0
                    ? a_total_gpu - b_total_gpu
                    : a_used_gpu - b_used_gpu && a_total_gpu - b_total_gpu;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "pod":
          datas.sort((a: any, b: any) => {
            let a_used_pod: number = change_unit(a.metadata.usedPod, unit_provide, false);
            let b_used_pod: number = change_unit(b.metadata.usedPod, unit_provide, false);
            let a_total_pod: number =
              change_unit(a.metadata.totalPod, unit_provide, false) === -1 ? Infinity : change_unit(a.metadata.totalPod, unit_provide, false);
            let b_total_pod: number =
              change_unit(b.metadata.totalPod, unit_provide, false) === -1 ? Infinity : change_unit(b.metadata.totalPod, unit_provide, false);
            const num: number =
              a_total_pod === Infinity && b_total_pod === Infinity
                ? a_used_pod - b_used_pod
                : a_total_pod !== Infinity && b_total_pod !== Infinity
                ? (a_total_pod === 0 && b_total_pod !== 0) || (a_total_pod !== 0 && b_total_pod === 0)
                  ? a_used_pod - b_used_pod
                  : a_used_pod === 0 && b_used_pod === 0
                  ? a_total_pod - b_total_pod
                  : a_used_pod / a_total_pod - b_used_pod / b_total_pod
                : a_used_pod === 0 && b_used_pod === 0
                ? a_total_pod - b_total_pod
                : a_used_pod - b_used_pod && a_total_pod - b_total_pod;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "pvc":
          datas.sort((a: any, b: any) => {
            let a_used_pvc: number = change_unit(a.metadata.usedDisk, unit_provide, false);
            let b_used_pvc: number = change_unit(b.metadata.usedDisk, unit_provide, false);
            let a_total_pvc: number =
              change_unit(a.metadata.totalDisk, unit_provide, false) === -1 ? Infinity : change_unit(a.metadata.totalDisk, unit_provide, false);
            let b_total_pvc: number =
              change_unit(b.metadata.totalDisk, unit_provide, false) === -1 ? Infinity : change_unit(b.metadata.totalDisk, unit_provide, false);
            const num: number =
              a_total_pvc === Infinity && b_total_pvc === Infinity
                ? a_used_pvc - b_used_pvc
                : a_total_pvc !== Infinity && b_total_pvc !== Infinity
                ? (a_total_pvc === 0 && b_total_pvc !== 0) || (a_total_pvc !== 0 && b_total_pvc === 0)
                  ? a_used_pvc - b_used_pvc
                  : a_used_pvc === 0 && b_used_pvc === 0
                  ? a_total_pvc - b_total_pvc
                  : a_used_pvc / a_total_pvc - b_used_pvc / b_total_pvc
                : a_used_pvc === 0 && b_used_pvc === 0
                ? a_total_pvc - b_total_pvc
                : a_used_pvc - b_used_pvc && a_total_pvc - b_total_pvc;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
      }
      set_workspaces_list(datas.slice(0, 5));
    }
  }, [workspaces, order_name, order_desc, set_workspaces_list, unit_provide]);

  useEffect((): void => {
    set_workspace_column([
      {
        title: "",
        dataIndex: "icon",
        width: 0.5,
        render: () => (
          <img src={theme === "dark_blue" ? workspace_icon_dark_blue : theme === "black_gray" ? workspace_icon_black_gray : workspace_icon} alt="" />
        ),
      },
      {
        title: <FormattedMessage id="workspace" />,
        dataIndex: "metadata",
        key: "workspace",
        width: 220,
        className: "text-ellipsis font-w-6",
        sorter: true,
        // sorter: (a, b) => a.metadata.labels.name.localeCompare(b.metadata.labels.name),
        render: ({ labels }: any) => {
          return {
            children: labels?.name,
            props: {
              "data-title": "Name: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            CPU (Core)
            <br />
            <span className="font-gray">
              <FormattedMessage id="request_limit" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "cpu",
        className: "text-ellipsis font-w-6",
        // sorter: true,
        // sorter: (a, b) => {
        //     let a_req_cpu: number = Number(a.metadata.requestCPU);
        //     let b_req_cpu: number = Number(b.metadata.requestCPU);
        //     let a_total_cpu: number = Number(a.metadata.totalCPU);
        //     let b_total_cpu: number = Number(b.metadata.totalCPU);
        //     return (a_req_cpu / a_total_cpu) - (b_req_cpu / b_total_cpu);
        // },
        render: (metadata: any) => {
          const cpu: string = metadata.requestCPU;
          const cpu_limit_str: string = metadata.limitCPU;
          const cpu_total_str: string = metadata.totalCPU;
          const cpu_number: number = cpu ? (cpu.indexOf(" ") === -1 ? Number(cpu) : Number(cpu.slice(0, cpu.indexOf(" ")))) : 0;
          const cpu_limit_number: number = cpu_limit_str
            ? cpu_limit_str.indexOf(" ") === -1
              ? Number(cpu_limit_str)
              : Number(cpu_limit_str.slice(0, cpu_limit_str.indexOf(" ")))
            : 0;
          const cpu_total: number = cpu_total_str
            ? cpu_total_str.indexOf(" ") === -1
              ? Number(cpu_total_str)
              : Number(cpu_total_str.slice(0, cpu_total_str.indexOf(" ")))
            : 0;
          return {
            children: (
              <Fragment>
                <div>
                  {cpu_total_str === '*' || cpu === '0' ? '0.00' : cpu_total_str === '0' ? 'Unlimited' : ((cpu_number / cpu_total) * 100).toFixed(2)}% / {cpu_total_str === '*' || cpu_limit_str === '0' ? '0.00' : cpu_total_str === '0' ? 'Unlimited' : ((cpu_limit_number / cpu_total) * 100).toFixed(2)}%
                </div>
                <div>
                  {cpu_number.toFixed(2)} / {cpu_limit_number.toFixed(2)}
                </div>
              </Fragment>
            ),
            props: {
              "data-title": "Request/Limit of CPU: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            CPU (Core)
            <br />
            <span className="font-gray">
              <FormattedMessage id="usage_quota" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "cpuUsage",
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_cpu: number = Number(a.metadata.usedCPU);
        //     let b_used_cpu: number = Number(b.metadata.usedCPU);
        //     let a_total_cpu: number = a.metadata.totalCPU === '*' ? Infinity : Number(a.metadata.totalCPU);
        //     let b_total_cpu: number = b.metadata.totalCPU === '*' ? Infinity : Number(b.metadata.totalCPU);
        //     return a_total_cpu === Infinity && b_total_cpu === Infinity
        //         ? a_used_cpu - b_used_cpu
        //         : a_total_cpu !== Infinity && b_total_cpu !== Infinity
        //             ? (a_total_cpu === 0 && b_total_cpu !== 0) || (a_total_cpu !== 0 && b_total_cpu === 0)
        //                 ? a_used_cpu - b_used_cpu
        //                 : a_used_cpu === 0 && b_used_cpu === 0
        //                     ? a_total_cpu - b_total_cpu
        //                     : a_used_cpu / a_total_cpu - b_used_cpu / b_total_cpu
        //             : a_used_cpu === 0 && b_used_cpu === 0
        //                 ? a_total_cpu - b_total_cpu
        //                 : a_used_cpu - b_used_cpu && a_total_cpu - b_total_cpu;
        // },
        width: 200,
        render: (metadata: any) => {
          const cpu_t: string = metadata && metadata.totalCPU,
            cpu_u: string = metadata && metadata.usedCPU;
          return {
            children: metadata && (
              <Fragment>
                <div className="font-w-6">{cpu_t === "*" || cpu_u === '0' ? "0.00%" : cpu_t === "0" ? "Unlimited" : `${((Number(cpu_u) / Number(cpu_t) || 0) * 100).toFixed(2)}%`}</div>
                {Number(cpu_u).toFixed(2)} / {cpu_t === "*" ? "Unlimited" : Number(cpu_t).toFixed(2)}
              </Fragment>
            ),
            props: {
              "data-title": "CPU: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            <FormattedMessage id="memory" /> ({unit_provide})<br />
            <span className="font-gray">
              <FormattedMessage id="request_limit" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "memoryReq",
        className: "text-ellipsis font-w-6",
        // sorter: true,
        // sorter: (a, b) => {
        //     let a_req_memory: number = change_unit(a.metadata.requestMemory, unit_provide, false),
        //         b_req_memory: number = change_unit(b.metadata.requestMemory, unit_provide, false),
        //         a_total_memory: number = change_unit(a.metadata.totalMemory, unit_provide, false),
        //         b_total_memory: number = change_unit(b.metadata.totalMemory, unit_provide, false);
        //     return (a_req_memory / a_total_memory) - (b_req_memory / b_total_memory);
        // },
        render: (metadata: any) => {
          const memory_str: string = metadata.requestMemory;
          const memory_limit_str: string = metadata.limitMemory;
          const memory_total_str: string = metadata.totalMemory;
          const memory_num: number = memory_str
            ? memory_str.indexOf(" ") === -1
              ? Number(memory_str)
              : Number(memory_str.slice(0, memory_str.indexOf(" ")))
            : 0;
          const memory_limit_num: number = memory_limit_str
            ? memory_limit_str.indexOf(" ") === -1
              ? Number(memory_limit_str)
              : Number(memory_limit_str.slice(0, memory_limit_str.indexOf(" ")))
            : 0;
          const memory_total: number = memory_total_str
            ? memory_total_str.indexOf(" ") === -1
              ? Number(memory_total_str)
              : Number(memory_total_str.slice(0, memory_total_str.indexOf(" ")))
            : 0;
          return {
            children: (
              <Fragment>
                <div>
                  {memory_total_str === '*' || memory_str === '0' ? '0.00' : memory_total_str === '0' ? 'Unlimited' : ((memory_num / memory_total) * 100).toFixed(2)}% / {memory_total_str === '*' ||  memory_limit_str === '0' ? '0.00' : memory_total_str === '0' ? 'Unlimited' : ((memory_limit_num / memory_total) * 100).toFixed(2)}%
                </div>
                <div>
                  {change_unit(memory_num, unit_provide, false).toFixed(2)} / {change_unit(memory_limit_num, unit_provide, false).toFixed(2)}
                </div>
              </Fragment>
            ),
            props: {
              "data-title": "Request/Limit of Memory: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            <FormattedMessage id="memory" /> ({unit_provide})<br />
            <span className="font-gray">
              <FormattedMessage id="usage_quota" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "memory",
        width: 200,
        className: "text-ellipsis",
        sorter: true,
        defaultSortOrder: "descend",
        // sorter: (a, b) => {
        //     let a_used_memory: number = change_unit(a.metadata.usedMemory, unit_provide, false);
        //     let b_used_memory: number = change_unit(b.metadata.usedMemory, unit_provide, false);
        //     let a_total_memory: number = change_unit(a.metadata.totalMemory, unit_provide, false) === -1 ? Infinity : change_unit(a.metadata.totalMemory, unit_provide, false);
        //     let b_total_memory: number = change_unit(b.metadata.totalMemory, unit_provide, false) === -1 ? Infinity : change_unit(b.metadata.totalMemory, unit_provide, false);
        //     return a_total_memory === Infinity && b_total_memory === Infinity
        //         ? a_used_memory - b_used_memory
        //         : a_total_memory !== Infinity && b_total_memory !== Infinity
        //             ? (a_total_memory === 0 && b_total_memory !== 0) || (a_total_memory !== 0 && b_total_memory === 0)
        //                 ? a_used_memory - b_used_memory
        //                 : a_used_memory === 0 && b_used_memory === 0
        //                     ? a_total_memory - b_total_memory
        //                     : a_used_memory / a_total_memory - b_used_memory / b_total_memory
        //             : a_used_memory === 0 && b_used_memory === 0
        //                 ? a_total_memory - b_total_memory
        //                 : a_used_memory - b_used_memory && a_total_memory - b_total_memory;
        // },
        render: (metadata: any) => {
          const memory_t: string = metadata.totalMemory,
            memory_u: string = metadata.usedMemory;
          return {
            children: metadata && (
              <Fragment>
                <div className="font-w-6">{memory_t === "*" || memory_u === '0'  ? "0.00%" : memory_t === "0" ? "Unlimited" : `${((Number(memory_u) / Number(memory_t) || 0) * 100).toFixed(2)}%`}</div>
                {(Number(change_unit(memory_u, unit_provide, false)) || 0).toFixed(2)} /{" "}
                {memory_t === "*" ? "Unlimited" : change_unit(memory_t, unit_provide, false).toFixed(2)}
              </Fragment>
            ),
            props: {
              "data-title": "Memory: ",
            },
          };
        },
      },
      {
        title: `${formatMessage({ id: "rootfs" })} (${unit_provide})`,
        dataIndex: "metadata",
        key: "rootfs",
        width: 200,
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_rootfs: number = change_unit(a.metadata.usedRootfs, unit_provide, false);
        //     let b_used_rootfs: number = change_unit(b.metadata.usedRootfs, unit_provide, false);
        //     let a_total_rootfs: number = change_unit(a.metadata.totalRootfs, unit_provide, false) === -1 ? Infinity : change_unit(a.metadata.totalRootfs, unit_provide, false);
        //     let b_total_rootfs: number = change_unit(b.metadata.totalRootfs, unit_provide, false) === -1 ? Infinity : change_unit(b.metadata.totalRootfs, unit_provide, false);
        //     return a_total_rootfs === Infinity && b_total_rootfs === Infinity
        //         ? a_used_rootfs - b_used_rootfs
        //         : a_total_rootfs !== Infinity && b_total_rootfs !== Infinity
        //             ? (a_total_rootfs === 0 && b_total_rootfs !== 0) || (a_total_rootfs !== 0 && b_total_rootfs === 0)
        //                 ? a_used_rootfs - b_used_rootfs
        //                 : a_used_rootfs === 0 && b_used_rootfs === 0
        //                     ? a_total_rootfs - b_total_rootfs
        //                     : a_used_rootfs / a_total_rootfs - b_used_rootfs / b_total_rootfs
        //             : a_used_rootfs === 0 && b_used_rootfs === 0
        //                 ? a_total_rootfs - b_total_rootfs
        //                 : a_used_rootfs - b_used_rootfs && a_total_rootfs - b_total_rootfs;
        // },
        render: (metadata: any) => {
          const rootfs_u: string = metadata.usedRootfs,
            rootfs_t: string = metadata.totalRootfs;
          return {
            children: metadata && (
              <Fragment>
                <div className="font-w-6">{rootfs_t === "*" || rootfs_u === '0' ? "0.00%" : rootfs_t === "0" ? "Unlimited" : `${((Number(rootfs_u) / Number(rootfs_t) || 0) * 100).toFixed(2)}%`}</div>
                {(Number(change_unit(rootfs_u, unit_provide, false)) || 0).toFixed(2)} /{" "}
                {rootfs_t === "*" ? "Unlimited" : change_unit(rootfs_t, unit_provide, false).toFixed(2)}
              </Fragment>
            ),
            props: {
              "data-title": "Rootfs: ",
            },
          };
        },
      },
      {
        title: "GPU",
        dataIndex: "metadata",
        key: "gpu",
        width: 200,
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_pod: number = change_unit(a.metadata.usedPod, unit_provide, false);
        //     let b_used_pod: number = change_unit(b.metadata.usedPod, unit_provide, false);
        //     let a_total_pod: number = change_unit(a.metadata.totalPod, unit_provide, false) === -1 ? Infinity : change_unit(a.metadata.totalPod, unit_provide, false);
        //     let b_total_pod: number = change_unit(b.metadata.totalPod, unit_provide, false) === -1 ? Infinity : change_unit(b.metadata.totalPod, unit_provide, false);
        //     return a_total_pod === Infinity && b_total_pod === Infinity
        //         ? a_used_pod - b_used_pod
        //         : a_total_pod !== Infinity && b_total_pod !== Infinity
        //             ? (a_total_pod === 0 && b_total_pod !== 0) || (a_total_pod !== 0 && b_total_pod === 0)
        //                 ? a_used_pod - b_used_pod
        //                 : a_used_pod === 0 && b_used_pod === 0
        //                     ? a_total_pod - b_total_pod
        //                     : a_used_pod / a_total_pod - b_used_pod / b_total_pod
        //             : a_used_pod === 0 && b_used_pod === 0
        //                 ? a_total_pod - b_total_pod
        //                 : a_used_pod - b_used_pod && a_total_pod - b_total_pod;
        // },
        render: (metadata: any) => {
          const pod_t: string = metadata.totalGPU,
            pod_u: string = metadata.usedGPU;
          return {
            children: metadata && (
              <Fragment>
                <div className="font-w-6">{pod_t === "*" || pod_u === '0' ? '0.00%' : pod_t === "0" ? "Unlimited" : `${((Number(pod_u) / Number(pod_t) || 0) * 100).toFixed(2)}%`}</div>
                {(Number(pod_u) || 0).toFixed(0)} / {pod_t === "*" ? "Unlimited" : Number(pod_t).toFixed(0)}
              </Fragment>
            ),
            props: {
              "data-title": "GPU: ",
            },
          };
        },
      },
      {
        title: "Pod",
        dataIndex: "metadata",
        key: "pod",
        width: 200,
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_pod: number = change_unit(a.metadata.usedPod, unit_provide, false);
        //     let b_used_pod: number = change_unit(b.metadata.usedPod, unit_provide, false);
        //     let a_total_pod: number = change_unit(a.metadata.totalPod, unit_provide, false) === -1 ? Infinity : change_unit(a.metadata.totalPod, unit_provide, false);
        //     let b_total_pod: number = change_unit(b.metadata.totalPod, unit_provide, false) === -1 ? Infinity : change_unit(b.metadata.totalPod, unit_provide, false);
        //     return a_total_pod === Infinity && b_total_pod === Infinity
        //         ? a_used_pod - b_used_pod
        //         : a_total_pod !== Infinity && b_total_pod !== Infinity
        //             ? (a_total_pod === 0 && b_total_pod !== 0) || (a_total_pod !== 0 && b_total_pod === 0)
        //                 ? a_used_pod - b_used_pod
        //                 : a_used_pod === 0 && b_used_pod === 0
        //                     ? a_total_pod - b_total_pod
        //                     : a_used_pod / a_total_pod - b_used_pod / b_total_pod
        //             : a_used_pod === 0 && b_used_pod === 0
        //                 ? a_total_pod - b_total_pod
        //                 : a_used_pod - b_used_pod && a_total_pod - b_total_pod;
        // },
        render: (metadata: any) => {
          const pod_t: string = metadata.totalPod,
            pod_u: string = metadata.usedPod;
          return {
            children: metadata && (
              <Fragment>
                <div className="font-w-6">{pod_t === "*" || pod_u === '0' ? '0.00%' : pod_t === "0" ? "Unlimited" : `${((Number(pod_u) / Number(pod_t) || 0) * 100).toFixed(2)}%`}</div>
                {(Number(pod_u) || 0).toFixed(0)} / {pod_t === "*" ? "Unlimited" : Number(pod_t).toFixed(0)}
              </Fragment>
            ),
            props: {
              "data-title": "Pod: ",
            },
          };
        },
      },
      {
        title: `${formatMessage({ id: "pvc_disk" })} (${unit_provide})`,
        dataIndex: "metadata",
        key: "pvc",
        width: 200,
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_pvc: number = change_unit(a.metadata.usedDisk, unit_provide, false);
        //     let b_used_pvc: number = change_unit(b.metadata.usedDisk, unit_provide, false);
        //     let a_total_pvc: number = change_unit(a.metadata.totalDisk, unit_provide, false) === -1 ? Infinity : change_unit(a.metadata.totalDisk, unit_provide, false);
        //     let b_total_pvc: number = change_unit(b.metadata.totalDisk, unit_provide, false) === -1 ? Infinity : change_unit(b.metadata.totalDisk, unit_provide, false);
        //     return a_total_pvc === Infinity && b_total_pvc === Infinity
        //         ? a_used_pvc - b_used_pvc
        //         : a_total_pvc !== Infinity && b_total_pvc !== Infinity
        //             ? (a_total_pvc === 0 && b_total_pvc !== 0) || (a_total_pvc !== 0 && b_total_pvc === 0)
        //                 ? a_used_pvc - b_used_pvc
        //                 : a_used_pvc === 0 && b_used_pvc === 0
        //                     ? a_total_pvc - b_total_pvc
        //                     : a_used_pvc / a_total_pvc - b_used_pvc / b_total_pvc
        //             : a_used_pvc === 0 && b_used_pvc === 0
        //                 ? a_total_pvc - b_total_pvc
        //                 : a_used_pvc - b_used_pvc && a_total_pvc - b_total_pvc;
        // },
        render: (metadata: any) => {
          const pvc_t: string = metadata.totalDisk,
            pvc_u: string = metadata.usedDisk;
          return {
            children: metadata && (
              <Fragment>
                <div className="font-w-6">{pvc_t === "*" || pvc_u === '0' ? '0.00%' : pvc_t === "0" ? "Unlimited" : `${((Number(pvc_u) / Number(pvc_t) || 0) * 100).toFixed(2)}%`}</div>
                {(Number(change_unit(pvc_u, unit_provide, false)) || 0).toFixed(2)} / {pvc_t === "*" ? "Unlimited" : change_unit(pvc_t, unit_provide, false).toFixed(2)}
              </Fragment>
            ),
            props: {
              "data-title": "PVC Disk: ",
            },
          };
        },
      },
    ]);
  }, [unit_provide, formatMessage, theme]);

  useEffect(() => {
    if (cluster_info) {
      const cluster_info_panel_new: JSX.Element[] = [],
        usedcpu: string = cluster_info.usedCPU ? cluster_info.usedCPU : "",
        usedcpu_to_precision: string = usedcpu ? usedcpu : "";

      let cluster_info_display_new: string[] | undefined = ["globalAdmin", "clusterAdmin", "clusterOwner"].includes(user_info.role)
        ? [
            "version",
            cluster_info.version || "",
            "",
            "node",
            cluster_info.node || "",
            "/nodes",
            "cpu",
            usedcpu ? `${usedcpu_to_precision} ${usedcpu ? "cores" : ""}` : "",
            "",
            "memory",
            cluster_info.usedMemory ? `${change_unit(cluster_info.usedMemory, unit_provide, false)} ${unit_provide}` : "",
            "",
            "rootfs",
            cluster_info.usedRootfs ? `${change_unit(cluster_info.usedRootfs, unit_provide, false)} ${unit_provide}` : "",
            "",
            "pod",
            cluster_info.usedPod ? Number(cluster_info.usedPod).toFixed(0) : "",
            "",
            "pvc_disk",
            cluster_info.usedDisk ? `${change_unit(cluster_info.usedDisk, unit_provide, false)} ${unit_provide}` : "",
            "",
            "gpu",
            cluster_info.usedGPU || "",
            "",
            "workspace",
            cluster_info.workspace || "",
            "cluster-info/workspaces",
            "namespace",
            cluster_info.namespace || "",
            "workspace-info/namespaces",
            "user",
            cluster_info.user || "",
            "",
          ]
        : cluster_info_display;

      if (cluster_info_display_new?.length) {
        let name: string;
        for (let i = 0; i < cluster_info_display_new.length; i += 3) {
          name = cluster_info_display_new[i];
          const link_path: string = cluster_info_display_new[i + 2];
          cluster_info_panel_new[i] = (
            <div
              className={`resource_card no-pad d-flex justify-center align-items-center flex-1 ${link_path.length && "pointer"}`}
              onClick={() => {
                link_path.length && props.history.push({ pathname: link_path, state: { type: cluster_selected?.labels?.type } });
              }}
              key={name}
            >
              <Row className="resource_info border">
                <Col xxl={24} className="strong text-ellipsis" title={cluster_info_display_new[i + 1]}>
                  {cluster_info_display_new[i + 1] || (
                    <Skeleton className="ant-col-sm-16 ant-col-sm-offset-4" title={{ width: "100%" }} paragraph={{ rows: 0 }} active />
                  )}
                </Col>
                <Col xxl={24} className="span text-ellipsis">
                  {formatMessage({ id: cluster_info_display_new[i] })}
                </Col>
              </Row>
            </div>
          );
        }
        set_cluster_info_panel(cluster_info_panel_new);
      }

      if (cluster_info.display) {
        const cluster_status_new: JSX.Element[] = [],
          display: (string | number | undefined)[] = cluster_info.display;
        for (let i = 0; i < 30; i += 5) {
          const used: number | undefined = display[i + 3] as number | undefined,
            total: number | undefined = display[i + 4] as number | undefined;
          cluster_status_new[i] = (
            <Col flex="1" className="cluster_status_card" key={i / 5}>
              <Row className="cluster_status_row d-flex flex-wrap">
                <Col xl={6} lg={7} md={8} sm={9} xs={10}>
                  <CircularProgressbar
                    value={used || 0}
                    maxValue={total === 0 ? Infinity : total}
                    strokeWidth={12}
                    text={used && total ? `${total === 0 ? "0" : ((used / total) * 100).toFixed(2)}%` : "0.00%"}
                    className="progress_circle"
                    styles={buildStyles({ trailColor: `${theme === "black_gray" ? "dcdce0" : "dcdce0"}` })}
                    // styles={buildStyles({
                    //   textColor: "4a5974",
                    //   pathColor: '',
                    //   trailColor: "dcdce0",
                    // })}
                  />
                </Col>
                <Col xl={18} lg={17} md={16} sm={15} xs={14}>
                  <Row className="status_detail">
                    <Col sm={24} className="font-w-6">
                      {
                        [
                          formatMessage({ id: "cpu" }),
                          formatMessage({ id: "memory" }),
                          formatMessage({ id: "rootfs" }),
                          formatMessage({ id: "pod" }),
                          formatMessage({ id: "pvc_disk" }),
                          formatMessage({ id: "gpu" }),
                        ][i / 5]
                      }
                    </Col>
                    <Col
                      sm={24}
                      title={`${i === 0 || i === 15 || i === 25 ? used : change_unit(used, unit_provide, false)} / ${
                        i === 0 ? display[i + 1] : i === 15 || i === 25 ? Number(display[i + 1]).toFixed(0) : change_unit(display[i + 1], unit_provide, false)
                      } ${i === 0 ? " cores" : i === 15 || i === 25 ? "" : unit_provide}`}
                    >
                      <Row align="middle">
                        <Col className="font-w-6 font-20 number">
                          {/* {(i === 0 || i === 15 ? used : change_unit(used, unit_provide, false)) || (
                            <Skeleton title={{ width: "50px" }} paragraph={{ rows: 0 }} active />
                          )} */}
                          {i === 0 || i === 15 || i === 25 ? used || 0 : change_unit(used, unit_provide, false)}
                        </Col>
                        <Col className="line-middle" sm={2}>
                          /
                        </Col>
                        <Col className="number">
                          {/* {(i === 0 ? display[i + 1] : i === 15 ? Number(display[i + 1]).toFixed(0) : change_unit(display[i + 1], unit_provide, false)) || (
                            <Skeleton className="ant-col pr-6" title={{ width: "50px" }} paragraph={{ rows: 0 }} active />
                          )} */}
                          {i === 0 ? display[i + 1] || 0 : i === 15 || i === 25 ? Number(display[i + 1] || 0).toFixed(0) : change_unit(display[i + 1], unit_provide, false)}
                        </Col>
                        <Col className="pl-4">{i === 0 ? "cores" : i === 15 || i === 25 ? "" : ` ${unit_provide}`}</Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          );
          set_cluster_status(cluster_status_new);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    unit_provide,
    props,
    cluster_info,
    formatMessage,
    workspaces,
    namespaces,
    info_key,
    user_info.role,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cluster_selected?.name,
    cluster_info_display,
    theme,
  ]);

  const physical_resource_usage = useMemo(() => {
    const { usedCPU, usedMemory, usedRootfs, usedPod, usedDisk, totalCPU, totalMemory, totalRootfs, totalPod, totalDisk, usedGPU, totalGPU } = ((((info_key[
        user_info.role || ""
      ] === "workspace"
        ? workspace_selected || (workspaces && workspaces[0])?.metadata
        : namespace_selected || (namespaces && namespaces[0])?.metadata) || {}) as unknown) as workspace_info_type) || {
        usedCPU: "",
        usedMemory: "",
        usedRootfs: "",
        usedPod: "",
        usedDisk: "",
        totalCPU: "",
        totalMemory: "",
        totalRootfs: "",
        totalPod: "",
        totalDisk: "",
        usedGPU: "",
        totalGPU: "",
      },
      physical_resource_usage_new: JSX.Element[] = [],
      physical_resource_usage_arr: string[] | undefined = [
        "cpu",
        usedCPU ? Number(usedCPU).toFixed(2) : "",
        totalCPU ? `${totalCPU === "*" ? "*" : Number(totalCPU).toFixed(2)}` : "",
        "usedCPU",
        "memory",
        usedMemory ? `${change_unit(usedMemory, unit_provide, false)}` : "",
        totalMemory ? `${totalMemory === "*" ? "*" : change_unit(totalMemory, unit_provide, false)}` : "",
        "usedMemory",
        "rootfs",
        usedRootfs ? `${change_unit(usedRootfs, unit_provide, false)}` : "",
        totalRootfs ? `${totalRootfs === "*" ? "*" : change_unit(totalRootfs, unit_provide, false)}` : "",
        "usedRootfs",
        "pod",
        usedPod ? usedPod : "",
        totalPod ? totalPod : "",
        "usedPod",
        "pvc_disk",
        usedDisk ? `${change_unit(usedDisk, unit_provide, false)}` : "",
        totalDisk ? `${totalDisk === "*" ? "*" : change_unit(totalDisk, unit_provide, false)}` : "",
        "usedDisk",
        "gpu",
        usedGPU ? usedGPU : "",
        totalGPU ? totalGPU : "",
        "usedGPU",
      ];

    // get_float: (num: number) => number = (num: number): number => parseFloat(num.toFixed(3));
    let name: string, used: number, total: number, usage_display: string, used_str: string, total_str: string;
    for (let i = 0; i < physical_resource_usage_arr.length; i += 4) {
      used_str = physical_resource_usage_arr[i + 1];
      total_str = physical_resource_usage_arr[i + 2]
        ? physical_resource_usage_arr[i + 2].indexOf("*") === -1
          ? physical_resource_usage_arr[i + 2]
          : "Unlimited"
        : "";
      used = used_str ? (used_str.indexOf(" ") === -1 ? Number(used_str) : Number(used_str.slice(0, used_str.indexOf(" ")))) : 0;
      total = total_str
        ? total_str.indexOf(" ") === -1
          ? total_str.indexOf("*") === -1
            ? Number(total_str)
            : 1
          : Number(total_str.slice(0, total_str.indexOf(" ")))
        : 1;
      usage_display = physical_resource_usage_arr[i + 1];
      name = physical_resource_usage_arr[i];

      physical_resource_usage_new[i] = (
        <Col className="cluster_status_card" key={name}>
          <Row className="cluster_status_row">
            <Col xl={6} lg={7} md={8} sm={5} xs={6}>
              <CircularProgressbar
                value={total_str === "Unlimited" ? 0 : used}
                maxValue={total === 0 || total_str === "Unlimited" ? Infinity : total}
                strokeWidth={12}
                text={used && total ? `${total === 0 ? "0" : ((used / total) * 100).toFixed(2)}%` : "0.00%"}
                className="progress_circle"
                styles={buildStyles({ trailColor: `${theme === "black_gray" ? "dcdce0" : "dcdce0"}` })}
              />
            </Col>
            <Col xl={18} lg={17} md={16} sm={19} xs={18}>
              <Row className="status_detail">
                <Col sm={24} xs={24} className="font-w-6 text-ellipsis">
                  {formatMessage({ id: physical_resource_usage_arr[i] })}
                </Col>
                <Col
                  sm={24}
                  xs={24}
                  title={`${usage_display ? usage_display : "0"} / ${total ? total.toString() : total_str} ${
                    name === "cpu" ? (Number(total ? total.toString() : total_str) > 1 ? "cores" : "core") : (name === "pod" || name === 'gpu') ? "" : unit_provide
                  }`}
                >
                  <Row align="middle">
                    <Col className="font-w-6 font-20 number">
                      {usage_display ? usage_display : "0" || <Skeleton title={{ width: "50px" }} paragraph={{ rows: 0 }} active />}
                    </Col>
                    <Col className="px-6">/</Col>
                    <Col className="text_total_span text-ellipsis">
                      {total ? total.toString() : total_str || <Skeleton className="ant-col" title={{ width: "50px" }} paragraph={{ rows: 0 }} active />}
                    </Col>
                    <Col className="pl-4">
                      {name === "cpu" ? (Number(total ? total.toString() : total_str) > 1 ? "cores" : "core") : (name === "pod" || name === 'gpu') ? "" : unit_provide}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      );
    }
    return physical_resource_usage_new;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unit_provide, workspace_selected?.name, workspaces, namespace_selected?.name, namespaces, info_key, user_info.role, formatMessage, theme]);

  const handle_table_change = useCallback((_pagination: any, _filters: any, sorter: any) => {
    if (sorter.order) {
      set_order_desc(sorter.order);
    } else {
      set_order_desc("");
    }
    set_order_name(sorter.columnKey);
  }, []);

  const namespace_column: ColumnProps<namespaces_type_item>[] | undefined = useMemo(
    () => [
      {
        title: "",
        dataIndex: "icon",
        width: 0.5,
        render: () => (
          <img src={theme === "dark_blue" ? workspace_icon_dark_blue : theme === "black_gray" ? workspace_icon_black_gray : workspace_icon} alt="" />
        ),
      },
      {
        title: <FormattedMessage id="namespace" />,
        dataIndex: "metadata",
        key: "namespace",
        width: 220,
        className: "text-ellipsis font-w-6",
        sorter: true,
        // sorter: (a, b) => a.metadata.name.localeCompare(b.metadata.name),
        render: ({ name }: any): { children: any; props: object } => {
          return {
            children: name,
            props: {
              "data-title": "Name: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            CPU (Core)
            <br />
            <span className="font-gray">
              <FormattedMessage id="request_limit" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "cpu",
        className: "text-ellipsis font-w-6",
        // sorter: true,
        // sorter: (a, b) => {
        //     let a_req_cpu: number = Number(a.metadata.requestCPU);
        //     let b_req_cpu: number = Number(b.metadata.requestCPU);
        //     let a_total_cpu: number = Number(a.metadata.totalCPU);
        //     let b_total_cpu: number = Number(b.metadata.totalCPU);
        //     return (a_req_cpu / a_total_cpu) - (b_req_cpu / b_total_cpu);
        // },
        render: (metadata: any) => {
          const cpu: string = metadata.requestCPU;
          const cpu_limit_str: string = metadata.limitCPU;
          const cpu_total_str: string = metadata.totalCPU;
          const cpu_number: number = cpu ? (cpu.indexOf(" ") === -1 ? Number(cpu) : Number(cpu.slice(0, cpu.indexOf(" ")))) : 0;
          const cpu_limit_number: number = cpu_limit_str
            ? cpu_limit_str.indexOf(" ") === -1
              ? Number(cpu_limit_str)
              : Number(cpu_limit_str.slice(0, cpu_limit_str.indexOf(" ")))
            : 0;
          const cpu_total: number = cpu_total_str
            ? cpu_total_str.indexOf(" ") === -1
              ? Number(cpu_total_str)
              : Number(cpu_total_str.slice(0, cpu_total_str.indexOf(" ")))
            : 0;
          return {
            children: (
              <Fragment>
                <div>
                  {cpu_total_str === '*' || cpu === '0' ? '0.00' : cpu_total_str === '0' ? 'Unlimited' : ((cpu_number / cpu_total) * 100).toFixed(2)}% / {cpu_total_str === '*' || cpu_limit_str === '0' ? '0.00' : cpu_total_str === '0' ? 'Unlimited' : ((cpu_limit_number / cpu_total) * 100).toFixed(2)}%
                </div>
                <div>
                  {cpu_number.toFixed(2)} / {cpu_limit_number.toFixed(2)}
                </div>
              </Fragment>
            ),
            props: {
              "data-title": "Request/Limit of CPU: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            CPU (Core)
            <br />
            <span className="font-gray">
              <FormattedMessage id="usage_quota" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "cpuUsage",
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_cpu: number = remove_unit(unit_provide, a.metadata.usedCPU);
        //     let b_used_cpu: number = remove_unit(unit_provide, b.metadata.usedCPU);
        //     let a_total_cpu: number = remove_unit(unit_provide, a.metadata.totalCPU) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalCPU);
        //     let b_total_cpu: number = remove_unit(unit_provide, b.metadata.totalCPU) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalCPU);
        //     return a_total_cpu === Infinity && b_total_cpu === Infinity
        //         ? a_used_cpu - b_used_cpu
        //         : a_total_cpu !== Infinity && b_total_cpu !== Infinity
        //             ? (a_total_cpu === 0 && b_total_cpu !== 0) || (a_total_cpu !== 0 && b_total_cpu === 0)
        //                 ? a_used_cpu - b_used_cpu
        //                 : a_used_cpu === 0 && b_used_cpu === 0
        //                     ? a_total_cpu - b_total_cpu
        //                     : a_used_cpu / a_total_cpu - b_used_cpu / b_total_cpu
        //             : a_used_cpu === 0 && b_used_cpu === 0
        //                 ? a_total_cpu - b_total_cpu
        //                 : a_used_cpu - b_used_cpu && a_total_cpu - b_total_cpu;
        // },
        width: 200,
        render: (metadata: any) => {
          const cpu_t: string = metadata && metadata.totalCPU;
          const cpu_u: string = metadata && metadata.usedCPU;
          return {
            children: metadata && (
              <div>
                <div className="font-w-6">{cpu_t === "*" || cpu_u === '0' ? "0.00%" : cpu_t === "0" ? "Unlimited" : `${((Number(cpu_u) / Number(cpu_t)) * 100).toFixed(2)}%`}</div>
                <p>
                  {Number(cpu_u).toFixed(2)} / {cpu_t === "*" ? "Unlimited" : Number(cpu_t).toFixed(2)}
                </p>
              </div>
            ),
            props: {
              "data-title": "CPU: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            <FormattedMessage id="memory" /> ({unit_provide})<br />
            <span className="font-gray">
              <FormattedMessage id="request_limit" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "memory",
        className: "text-ellipsis font-w-6",
        // sorter: true,
        // sorter: (a, b) => {
        //     let a_req_memory: number = change_unit(a.metadata.requestMemory, unit_provide, false),
        //         b_req_memory: number = change_unit(b.metadata.requestMemory, unit_provide, false),
        //         a_total_memory: number = change_unit(a.metadata.totalMemory, unit_provide, false),
        //         b_total_memory: number = change_unit(b.metadata.totalMemory, unit_provide, false);
        //     return (a_req_memory / a_total_memory) - (b_req_memory / b_total_memory);
        // },
        render: (metadata: any) => {
          const memory_str: string = metadata.requestMemory;
          const memory_limit_str: string = metadata.limitMemory;
          const memory_total_str: string = metadata.totalMemory;
          const memory_num: number = memory_str
            ? memory_str.indexOf(" ") === -1
              ? Number(memory_str)
              : Number(memory_str.slice(0, memory_str.indexOf(" ")))
            : 0;
          const memory_limit_num: number = memory_limit_str
            ? memory_limit_str.indexOf(" ") === -1
              ? Number(memory_limit_str)
              : Number(memory_limit_str.slice(0, memory_limit_str.indexOf(" ")))
            : 0;
          const memory_total: number = memory_total_str
            ? memory_total_str.indexOf(" ") === -1
              ? Number(memory_total_str)
              : Number(memory_total_str.slice(0, memory_total_str.indexOf(" ")))
            : 0;
          return {
            children: (
              <Fragment>
                <div>
                  {memory_total_str === '*' || memory_str === '0' ? '0.00' : memory_total_str === '0' ? 'Unlimited' : ((memory_num / memory_total) * 100).toFixed(2)}% / {memory_total_str === '*' ||  memory_limit_str === '0' ? '0.00' : memory_total_str === '0' ? 'Unlimited' : ((memory_limit_num / memory_total) * 100).toFixed(2)}%
                </div>
                <div>
                  {change_unit(memory_num, unit_provide, false).toFixed(2)} / {change_unit(memory_limit_num, unit_provide, false).toFixed(2)}
                </div>
              </Fragment>
            ),
            props: {
              "data-title": "Request/Limit of Memory: ",
            },
          };
        },
      },
      {
        title: (
          <Fragment>
            <FormattedMessage id="memory" /> ({unit_provide})<br />
            <span className="font-gray">
              <FormattedMessage id="usage_quota" />
            </span>
          </Fragment>
        ),
        dataIndex: "metadata",
        key: "memoryUsage",
        width: 200,
        className: "text-ellipsis",
        sorter: true,
        defaultSortOrder: "descend",
        // sorter: (a, b) => {
        //     let a_used_memory: number = remove_unit(unit_provide, a.metadata.usedMemory);
        //     let b_used_memory: number = remove_unit(unit_provide, b.metadata.usedMemory);
        //     let a_total_memory: number = remove_unit(unit_provide, a.metadata.totalMemory) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalMemory);
        //     let b_total_memory: number = remove_unit(unit_provide, b.metadata.totalMemory) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalMemory);
        //     return a_total_memory === Infinity && b_total_memory === Infinity
        //         ? a_used_memory - b_used_memory
        //         : a_total_memory !== Infinity && b_total_memory !== Infinity
        //             ? (a_total_memory === 0 && b_total_memory !== 0) || (a_total_memory !== 0 && b_total_memory === 0)
        //                 ? a_used_memory - b_used_memory
        //                 : a_used_memory === 0 && b_used_memory === 0
        //                     ? a_total_memory - b_total_memory
        //                     : a_used_memory / a_total_memory - b_used_memory / b_total_memory
        //             : a_used_memory === 0 && b_used_memory === 0
        //                 ? a_total_memory - b_total_memory
        //                 : a_used_memory - b_used_memory && a_total_memory - b_total_memory;
        // },
        render: (metadata: any) => {
          const memory_t: string = metadata.totalMemory;
          const memory_u: string = metadata.usedMemory;
          return {
            children: metadata && (
              <div>
                <div className="font-w-6">{memory_t === "*" || memory_u === '0'  ? "0.00%" : memory_t === "0" ? "Unlimited" : `${((Number(memory_u) / Number(memory_t)) * 100).toFixed(2)}%`}</div>
                <p>
                  {change_unit(memory_u, unit_provide, false).toFixed(2)} / {memory_t === "*" ? "Unlimited" : change_unit(memory_t, unit_provide, false).toFixed(2)}
                </p>
              </div>
            ),
            props: {
              "data-title": "Memory: ",
            },
          };
        },
      },
      {
        title: `${formatMessage({ id: "rootfs" })} (${unit_provide})`,
        dataIndex: "metadata",
        key: "rootfs",
        width: 200,
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_rootfs: number = remove_unit(unit_provide, a.metadata.usedRootfs);
        //     let b_used_rootfs: number = remove_unit(unit_provide, b.metadata.usedRootfs);
        //     let a_total_rootfs: number = remove_unit(unit_provide, a.metadata.totalRootfs) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalRootfs);
        //     let b_total_rootfs: number = remove_unit(unit_provide, b.metadata.totalRootfs) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalRootfs);
        //     return a_total_rootfs === Infinity && b_total_rootfs === Infinity
        //         ? a_used_rootfs - b_used_rootfs
        //         : a_total_rootfs !== Infinity && b_total_rootfs !== Infinity
        //             ? (a_total_rootfs === 0 && b_total_rootfs !== 0) || (a_total_rootfs !== 0 && b_total_rootfs === 0)
        //                 ? a_used_rootfs - b_used_rootfs
        //                 : a_used_rootfs === 0 && b_used_rootfs === 0
        //                     ? a_total_rootfs - b_total_rootfs
        //                     : a_used_rootfs / a_total_rootfs - b_used_rootfs / b_total_rootfs
        //             : a_used_rootfs === 0 && b_used_rootfs === 0
        //                 ? a_total_rootfs - b_total_rootfs
        //                 : a_used_rootfs - b_used_rootfs && a_total_rootfs - b_total_rootfs;
        // },
        render: (metadata: any) => {
          const rootfs_u: string = metadata.usedRootfs;
          const rootfs_t: string = metadata.totalRootfs;
          return {
            children: metadata && (
              <div>
                <div className="font-w-6">
                  {rootfs_t === "*" || rootfs_u === '0' ? "0.00%" : rootfs_t === "0" ? "Unlimited" : `${((Number(rootfs_u) / Number(rootfs_t)) * 100).toFixed(2)}%`}
                </div>
                <p>
                  {change_unit(rootfs_u, unit_provide, false).toFixed(2)} / {rootfs_t === "*" ? "Unlimited" : change_unit(rootfs_t, unit_provide, false).toFixed(2)}
                </p>
              </div>
            ),
            props: {
              "data-title": "Rootfs: ",
            },
          };
        },
      },
      {
        title: "Pod",
        dataIndex: "metadata",
        key: "pod",
        width: 200,
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_pod: number = remove_unit(unit_provide, a.metadata.usedPod);
        //     let b_used_pod: number = remove_unit(unit_provide, b.metadata.usedPod);
        //     let a_total_pod: number = remove_unit(unit_provide, a.metadata.totalPod) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalPod);
        //     let b_total_pod: number = remove_unit(unit_provide, b.metadata.totalPod) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalPod);
        //     return a_total_pod === Infinity && b_total_pod === Infinity
        //         ? a_used_pod - b_used_pod
        //         : a_total_pod !== Infinity && b_total_pod !== Infinity
        //             ? (a_total_pod === 0 && b_total_pod !== 0) || (a_total_pod !== 0 && b_total_pod === 0)
        //                 ? a_used_pod - b_used_pod
        //                 : a_used_pod === 0 && b_used_pod === 0
        //                     ? a_total_pod - b_total_pod
        //                     : a_used_pod / a_total_pod - b_used_pod / b_total_pod
        //             : a_used_pod === 0 && b_used_pod === 0
        //                 ? a_total_pod - b_total_pod
        //                 : a_used_pod - b_used_pod && a_total_pod - b_total_pod;
        // },
        render: (metadata: any) => {
          const pod_t: string = metadata.totalPod;
          const pod_u: string = metadata.usedPod;
          return {
            children: metadata && (
              <div>
                <div className="font-w-6">{pod_t === "*" || pod_u === '0' ? '0.00%' : pod_t === "0" ? "Unlimited" : `${((Number(pod_u) / Number(pod_t)) * 100).toFixed(2)}%`}</div>
                <p>
                  {Number(pod_u).toFixed(0)} / {pod_t === "*" ? "Unlimited" : Number(pod_t).toFixed(0)}
                </p>
              </div>
            ),
            props: {
              "data-title": "Pod: ",
            },
          };
        },
      },
      {
        title: `${formatMessage({ id: "pvc_disk" })} (${unit_provide})`,
        dataIndex: "metadata",
        key: "pvc",
        width: 200,
        className: "text-ellipsis",
        sorter: true,
        // sorter: (a, b) => {
        //     let a_used_pvc: number = remove_unit(unit_provide, a.metadata.usedDisk);
        //     let b_used_pvc: number = remove_unit(unit_provide, b.metadata.usedDisk);
        //     let a_total_pvc: number = remove_unit(unit_provide, a.metadata.totalDisk) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalDisk);
        //     let b_total_pvc: number = remove_unit(unit_provide, b.metadata.totalDisk) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalDisk);
        //     return a_total_pvc === Infinity && b_total_pvc === Infinity
        //         ? a_used_pvc - b_used_pvc
        //         : a_total_pvc !== Infinity && b_total_pvc !== Infinity
        //             ? (a_total_pvc === 0 && b_total_pvc !== 0) || (a_total_pvc !== 0 && b_total_pvc === 0)
        //                 ? a_used_pvc - b_used_pvc
        //                 : a_used_pvc === 0 && b_used_pvc === 0
        //                     ? a_total_pvc - b_total_pvc
        //                     : a_used_pvc / a_total_pvc - b_used_pvc / b_total_pvc
        //             : a_used_pvc === 0 && b_used_pvc === 0
        //                 ? a_total_pvc - b_total_pvc
        //                 : a_used_pvc - b_used_pvc && a_total_pvc - b_total_pvc;
        // },
        render: (metadata: any) => {
          const pvc_t: string = metadata.totalDisk;
          const pvc_u: string = metadata.usedDisk;
          return {
            children: metadata && (
              <div>
                <div className="font-w-6">{pvc_t === "*" || pvc_u === '0' ? '0.00%' : pvc_t === "0" ? "Unlimited" : `${((Number(pvc_u) / Number(pvc_t)) * 100).toFixed(2)}%`}</div>
                <p>
                  {change_unit(pvc_u, unit_provide, false).toFixed(2)} / {pvc_t === "*" ? "Unlimited" : change_unit(pvc_t, unit_provide, false)}
                </p>
              </div>
            ),
            props: {
              "data-title": "PVC Disk: ",
            },
          };
        },
      },
    ],
    [unit_provide, formatMessage, theme]
  );

  const namespaces_list = useMemo(() => {
    if (Array.isArray(namespaces) && namespaces.length > 0) {
      const datas: any = [...namespaces];
      switch (order_name) {
        case "namespace":
          datas.sort((a: any, b: any) => {
            const num: number = a.metadata.name.localeCompare(b.metadata.name);
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "cpuUsage": {
          datas.sort((a: any, b: any) => {
            let a_used_cpu: number = remove_unit(unit_provide, a.metadata.usedCPU);
            let b_used_cpu: number = remove_unit(unit_provide, b.metadata.usedCPU);
            let a_total_cpu: number = remove_unit(unit_provide, a.metadata.totalCPU) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalCPU);
            let b_total_cpu: number = remove_unit(unit_provide, b.metadata.totalCPU) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalCPU);
            const num: number =
              a_total_cpu === Infinity && b_total_cpu === Infinity
                ? a_used_cpu - b_used_cpu
                : a_total_cpu !== Infinity && b_total_cpu !== Infinity
                ? (a_total_cpu === 0 && b_total_cpu !== 0) || (a_total_cpu !== 0 && b_total_cpu === 0)
                  ? a_used_cpu - b_used_cpu
                  : a_used_cpu === 0 && b_used_cpu === 0
                  ? a_total_cpu - b_total_cpu
                  : a_used_cpu / a_total_cpu - b_used_cpu / b_total_cpu
                : a_used_cpu === 0 && b_used_cpu === 0
                ? a_total_cpu - b_total_cpu
                : a_used_cpu - b_used_cpu && a_total_cpu - b_total_cpu;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        }
        case "memoryUsage":
          datas.sort((a: any, b: any) => {
            let a_used_memory: number = remove_unit(unit_provide, a.metadata.usedMemory);
            let b_used_memory: number = remove_unit(unit_provide, b.metadata.usedMemory);
            let a_total_memory: number =
              remove_unit(unit_provide, a.metadata.totalMemory) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalMemory);
            let b_total_memory: number =
              remove_unit(unit_provide, b.metadata.totalMemory) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalMemory);
            const num: number =
              a_total_memory === Infinity && b_total_memory === Infinity
                ? a_used_memory - b_used_memory
                : a_total_memory !== Infinity && b_total_memory !== Infinity
                ? (a_total_memory === 0 && b_total_memory !== 0) || (a_total_memory !== 0 && b_total_memory === 0)
                  ? a_used_memory - b_used_memory
                  : a_used_memory === 0 && b_used_memory === 0
                  ? a_total_memory - b_total_memory
                  : a_used_memory / a_total_memory - b_used_memory / b_total_memory
                : a_used_memory === 0 && b_used_memory === 0
                ? a_total_memory - b_total_memory
                : a_used_memory - b_used_memory && a_total_memory - b_total_memory;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "rootfs":
          datas.sort((a: any, b: any) => {
            let a_used_rootfs: number = remove_unit(unit_provide, a.metadata.usedRootfs);
            let b_used_rootfs: number = remove_unit(unit_provide, b.metadata.usedRootfs);
            let a_total_rootfs: number =
              remove_unit(unit_provide, a.metadata.totalRootfs) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalRootfs);
            let b_total_rootfs: number =
              remove_unit(unit_provide, b.metadata.totalRootfs) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalRootfs);
            const num: number =
              a_total_rootfs === Infinity && b_total_rootfs === Infinity
                ? a_used_rootfs - b_used_rootfs
                : a_total_rootfs !== Infinity && b_total_rootfs !== Infinity
                ? (a_total_rootfs === 0 && b_total_rootfs !== 0) || (a_total_rootfs !== 0 && b_total_rootfs === 0)
                  ? a_used_rootfs - b_used_rootfs
                  : a_used_rootfs === 0 && b_used_rootfs === 0
                  ? a_total_rootfs - b_total_rootfs
                  : a_used_rootfs / a_total_rootfs - b_used_rootfs / b_total_rootfs
                : a_used_rootfs === 0 && b_used_rootfs === 0
                ? a_total_rootfs - b_total_rootfs
                : a_used_rootfs - b_used_rootfs && a_total_rootfs - b_total_rootfs;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "pod":
          datas.sort((a: any, b: any) => {
            let a_used_pod: number = remove_unit(unit_provide, a.metadata.usedPod);
            let b_used_pod: number = remove_unit(unit_provide, b.metadata.usedPod);
            let a_total_pod: number = remove_unit(unit_provide, a.metadata.totalPod) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalPod);
            let b_total_pod: number = remove_unit(unit_provide, b.metadata.totalPod) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalPod);
            const num: number =
              a_total_pod === Infinity && b_total_pod === Infinity
                ? a_used_pod - b_used_pod
                : a_total_pod !== Infinity && b_total_pod !== Infinity
                ? (a_total_pod === 0 && b_total_pod !== 0) || (a_total_pod !== 0 && b_total_pod === 0)
                  ? a_used_pod - b_used_pod
                  : a_used_pod === 0 && b_used_pod === 0
                  ? a_total_pod - b_total_pod
                  : a_used_pod / a_total_pod - b_used_pod / b_total_pod
                : a_used_pod === 0 && b_used_pod === 0
                ? a_total_pod - b_total_pod
                : a_used_pod - b_used_pod && a_total_pod - b_total_pod;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
        case "pvc":
          datas.sort((a: any, b: any) => {
            let a_used_pvc: number = remove_unit(unit_provide, a.metadata.usedDisk);
            let b_used_pvc: number = remove_unit(unit_provide, b.metadata.usedDisk);
            let a_total_pvc: number = remove_unit(unit_provide, a.metadata.totalDisk) === -1 ? Infinity : remove_unit(unit_provide, a.metadata.totalDisk);
            let b_total_pvc: number = remove_unit(unit_provide, b.metadata.totalDisk) === -1 ? Infinity : remove_unit(unit_provide, b.metadata.totalDisk);
            const num: number =
              a_total_pvc === Infinity && b_total_pvc === Infinity
                ? a_used_pvc - b_used_pvc
                : a_total_pvc !== Infinity && b_total_pvc !== Infinity
                ? (a_total_pvc === 0 && b_total_pvc !== 0) || (a_total_pvc !== 0 && b_total_pvc === 0)
                  ? a_used_pvc - b_used_pvc
                  : a_used_pvc === 0 && b_used_pvc === 0
                  ? a_total_pvc - b_total_pvc
                  : a_used_pvc / a_total_pvc - b_used_pvc / b_total_pvc
                : a_used_pvc === 0 && b_used_pvc === 0
                ? a_total_pvc - b_total_pvc
                : a_used_pvc - b_used_pvc && a_total_pvc - b_total_pvc;
            return order_desc === "ascend" ? num : order_desc === "descend" ? -num : 0;
          });
          break;
      }
      return datas.slice(0, 5);
    }
  }, [namespaces, order_desc, order_name, unit_provide]);

  useEffect((): void => {
    const type_obj = cluster_selected?.labels;
    set_type_name(type_obj?.type as string);
    // sessionStorage.setItem('cluster_type', type_obj?.type as string);
  }, [cluster_selected, set_type_name]);

  useEffect((): void => {
    user_info && user_info.role === '' &&
      setTimeout(() => {
        set_norole_modal_visible(true)
      }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_info.role, set_norole_modal_visible])

  return (
    <TableListModalContext.Provider value={[table_list_modal, set_table_list_modal]}>
      <Col className="px-10 mt-20">
        <TableListModal />
        {sessionStorage.getItem("show_notice") === "true" && (
          <Row justify="space-between" className="p-6 notice_bg_clolor mb-10">
            <Col className="notice_color notice_desc" style={{ fontSize: "15px" }}>
              <FormattedMessage id="notice_front" />
              <a
                style={{ fontStyle: "oblique", textDecoration: "underline" }}
                href={`https://github.com/ensaas/document/blob/master/EnSaaS-K8s-Service/ReleaseNote_${lang === "zh-CN" || lang === "zh-TW" ? "ch" : "en"}.md`}
              >
                {" "}
                Release Notes{" "}
              </a>
              <FormattedMessage id="notice_back" />
            </Col>
            <Col className="text-right w-120">
              <Button style={{ fontSize: "14px" }} onClick={() => sessionStorage.setItem("show_notice", "false")}>
                <FormattedMessage id="close" />
              </Button>
            </Col>
          </Row>
        )}
        <Row className="breadcrumb_sticky console display_hidden">
          <Col className="mb-10">
            <BreadCrumbs />
          </Col>
        </Row>
        <Row className="px-6 mb-10" gutter={20}>
            {/* <Col xxl={9} xl={11} lg={15} md={16} sm={16} xs={20}><DropdownMenuSubscription /></Col> */}
            <Col xxl={9} xl={11} lg={15} md={16} sm={16} xs={20}>
              <span className="font-14"><FormattedMessage id="subscription_name" />:</span>
              {user_subscriptions && user_subscriptions[0] && user_subscriptions.length > 0 && <Select
                    className={`w-75 pl-20`}
                    showSearch
                    value={user_subscriptions.length > 0 ? user_info.subscription_id : ''}
                    // disabled={user_subscriptions.length < 2}
                    optionFilterProp="children"
                    dropdownRender={(menu) => (
                        <Fragment>
                            <div className="ant-select-item ant-select-item-group">With Resources Only</div>
                            {menu}
                        </Fragment>
                    )}
                    filterOption={(input, option) => (option?.key as string)?.toLocaleLowerCase().includes(input.toLocaleLowerCase())}
                    onChange={(event: string) => {
                        const subscription_id_new: string | undefined = (
                            user_subscriptions?.find(({ subscriptionId }: user_subscription) => subscriptionId === event) || (user_subscriptions || [])[0]
                        )?.subscriptionId;
                        if (subscription_id_new) {
                            new Cookies().set("subscription_id", subscription_id_new, {
                                domain: document.domain.substr(document.domain.indexOf(".")),
                                path: "/",
                            });
                            set_user_info((currentState) => ({ ...currentState, role: "", subscription_id: subscription_id_new }));
                        }

                    }}
                >
                    {Array.isArray(user_subscriptions) && user_subscriptions.length > 0 &&
                        user_subscriptions.map(({ subscriptionId, subscriptionName, company }: user_subscription) => (
                            <Option key={subscriptionName + company} value={subscriptionId}>
                                <Row
                                    title={
                                        formatMessage({ id: "subscription_name" }) +
                                        ": " +
                                        subscriptionName +
                                        "        " +
                                        formatMessage({ id: "company" }) +
                                        ": " +
                                        company
                                    }
                                >
                                    <Col lg={9} md={10} sm={11} xs={12} className="font-w-6 text-ellipsis">
                                        {subscriptionName}
                                    </Col>
                                    <Col lg={13} md={12} sm={11} xs={10} className="ml-10 text-ellipsis">
                                        {company}
                                    </Col>
                                </Row>
                            </Option>
                        ))}
                </Select>}
            </Col>
            <Col xl={7} lg={8} md={8} sm={8} xs={6}>
              <span className="font-14"><FormattedMessage id="cluster" />:</span>
              {clusters && clusters[0] && clusters[0].metadata && (
                <Select
                  className="w-75 pl-20"
                  showSearch
                  optionFilterProp="children"
                  value={cluster_selected?.name || sessionStorage.getItem("cluster") || clusters[0].metadata.name}
                  onChange={(event: string) => {
                    const cluster_selected_new: item | undefined = clusters.find((cluster: clusters_type_item) => cluster.metadata.name === event)?.metadata;
                    sessionStorage.setItem("cluster", cluster_selected_new?.name || "");
                    set_cluster_selected(cluster_selected_new);
                  }}
                >
                  {Array.isArray(clusters) &&
                    clusters.map((cluster: clusters_type_item) => (
                      <Option key={cluster.metadata.name} value={cluster.metadata.name}>
                        {cluster.metadata.name}
                      </Option>
                    ))}
                </Select>
              )}
            </Col>
        </Row>
        <Row className="px-6" justify="space-between">
          <Col xl={4} lg={5} md={7} sm={9} xs={11} className="card box_rounded border status_circle_card">
            <div className="p-2">
              <div className="admin_card pointer">
                <div className="account_icon">
                  <img src={profile_user} alt="" />
                </div>
                <div className="pl-4 id_card text-ellipsis" title={username_login}>
                  <FormattedMessage id="hi" /> {username_login}
                </div>
              </div>
            </div>
            <div className="p-2">
              <div className="admin_card pointer">
                <div className="account_icon">
                  <img src={id_card} alt="" />
                </div>
                <div className="pl-4 id_card text-ellipsis" title={user_info.role}>
                  {user_info.role}
                </div>
              </div>
            </div>
            {last && (
              <Col className="p-2">
                <div className="admin_card pointer">
                  <div className="account_icon">
                    <img src={login} alt="" />
                  </div>
                  <div className="pl-6 id_card d-flex flex-column">
                    <FormattedMessage id="last" />:<span>{last}</span>
                  </div>
                </div>
              </Col>
            )}
          </Col>
          <Col xl={20} lg={19} md={17} sm={15} xs={13} className="card box_rounded border">
            {" "}
            {/*Cluster Info card*/}
            <Row>
              <Col sm={24} className="card_title card_underline card_header_title">
                <FormattedMessage id={`${info_key[user_info.role || ""] || "cluster"}_information`} />
              </Col>
            </Row>
            <Row justify="space-between" className="d-flex flex-wrap">
              {cluster_info_panel}
            </Row>
          </Col>
        </Row>
        {Array.isArray(service_components) && !!service_components.length && (
          <Row className="px-6">
            <Collapse
              bordered={false}
              expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? (active_content ? 0 : 180) : active_content ? 180 : 0} />}
              expandIconPosition="right"
              defaultActiveKey="collapse_title"
              onChange={collapse_control}
              activeKey={active_collapse}
              className="card box_rounded border collapse_override"
            >
              <Panel
                disabled={true}
                showArrow={false}
                header={<span className="card_title card_header_title">Service Component</span>}
                className="collapse_override collapse_override_blue"
                key="collapse_title"
              >
                <Row justify="space-between">
                  {service_components.map((service_component: service_components_type_item) => (
                    <Col
                      sm={1}
                      lg={2}
                      className={`mt-10 img-94 text-center service_component ${service_component.service === "Monitoring" ? "pointer" : ""}`}
                      key={service_component.service}
                      onClick={() => {
                        if (service_component.service === "Monitoring") props.history.push("/monitor/workspaces");
                      }}
                    >
                      <Row>
                        <Col>
                          <img
                            className="service_img"
                            alt=""
                            src={service_component_imgs[service_component_imgs.findIndex((x) => x.key === service_component.service)].img}
                          />
                        </Col>
                        <Col>
                          <span
                            className="font-8"
                            style={{ opacity: service_component_imgs[service_component_imgs.findIndex((x) => x.key === service_component.service)].opacity }}
                          >
                            {service_component_imgs[service_component_imgs.findIndex((x) => x.key === service_component.service)].display}
                          </span>
                        </Col>
                      </Row>
                      <Row className="service_text">
                        <Col>
                          <span className="font-w-6 font-success">{service_component.normalCount}</span>
                          <span className="font-c-g">/{service_component.totalCount}</span>
                        </Col>
                      </Row>
                    </Col>
                  ))}
                </Row>
              </Panel>
              <Panel header="" key="arrow_icon" showArrow={active_content ? true : false} className="collapse_arrow_down" />
            </Collapse>
          </Row>
        )}
        <Row className="px-6">
          <Col sm={24} className="card box_rounded border">
            <div className="card_title card_underline card_header_title">
              <FormattedMessage id={`${info_key[user_info.role || ""] || "cluster"}_status`} />{info_key[user_info.role || ""]}
              {user_info.role !== "" && [
                info_key[user_info.role || ""] === "workspace" && workspaces && workspaces.length > 0 && workspaces[0] && (
                  <Select
                    className="ml-10 w-172"
                    key="workspace"
                    showSearch
                    optionFilterProp="children"
                    value={
                      workspace_selected?.labels?.name ||
                      workspaces.find((workspace: workspaces_type_item) => workspace?.metadata?.name === sessionStorage.getItem("workspace"))?.metadata?.labels
                        ?.name ||
                      (workspaces[0].metadata.labels && workspaces[0].metadata.labels.name)
                    }
                    onChange={(event: string) => {
                      const workspace_selected_new: item | undefined = workspaces.find(
                        (workspace: workspaces_type_item) => workspace.metadata?.labels?.name === event
                      )?.metadata,
                        workspace_selected_new_name: string | undefined = workspace_selected_new?.name;
                      workspace_selected_new_name && sessionStorage.setItem("workspace", workspace_selected_new_name);
                      workspace_selected_new && set_workspace_selected(workspace_selected_new);
                      // set_namespaces(workspace_selected_new?.namespaces);
                    }}
                  >
                    {Array.isArray(workspaces) &&
                      workspaces.map((workspace) => (
                        <Option key={workspace.metadata.uid} value={(workspace.metadata.labels || {}).name}>
                          {(workspace.metadata.labels || {}).name}
                        </Option>
                      ))}
                  </Select>
                ),
                info_key[user_info.role || ""] === "namespace" && namespaces && namespaces[0] && (
                  <Select
                    className="ml-10  w-172"
                    key="namespace"
                    showSearch
                    optionFilterProp="children"
                    value={
                      namespace_selected?.name ||
                      namespaces.find((namespace: namespaces_type_item) => namespace?.metadata?.name === sessionStorage.getItem("namespace"))?.metadata?.name ||
                      (namespaces[0].metadata && namespaces[0].metadata.name)
                    }
                    onChange={(event: string) => {
                      const namespace_selected_new: item | undefined = namespaces.find((namespace: namespaces_type_item) => namespace?.metadata?.name === event)
                        ?.metadata,
                        namespace_selected_new_name: string | undefined = namespace_selected_new?.name;
                      namespace_selected_new_name && sessionStorage.setItem("namespace", namespace_selected_new_name);
                      namespace_selected_new && set_namespace_selected(namespace_selected_new);
                    }}
                  >
                    {Array.isArray(namespaces) &&
                      namespaces.map((namespace) => (
                        <Option key={namespace.metadata.uid} value={namespace.metadata.name}>
                          {namespace.metadata.name}
                        </Option>
                      ))}
                  </Select>
                ),
              ]}
            </div>
            <Row justify="space-between" className="mt-20 flex-wrap">
              {user_info.role !== "" && (!info_key[user_info.role] ? cluster_status : <div className="grid grid_first_console w-100">{physical_resource_usage}</div>)}
            </Row>
            <div className="mt-20 card_title card_underline"></div>
            {
              typeof(user_info.role) === "string" &&  user_info.role !== "" ?
                <Tabs
                  className="tab_color global_table"
                  onChange={(activeKey: string) => {
                    destroy_worker();
                    set_tab_selected(usage_arr.current.indexOf(activeKey));
                  }}
                >
                  {user_info.role !== "" && [
                    !info_key[user_info.role] && (
                      <TabPane
                        className="node_table"
                        tab={
                          <span>
                            <FormattedMessage id="node_usage_t6" />
                            <Badge className="ml-5" count={(nodes || []).length} />
                          </span>
                        }
                        key="node_usage"
                      >
                        <Table
                          className="cursor-default scroll-x"
                          columns={node_column}
                          dataSource={nodes_list}
                          rowKey={(node: nodes_type_item) => node.metadata.name}
                          pagination={false}
                          onChange={handle_table_change}
                          showSorterTooltip={false}
                        />
                      </TabPane>
                    ),
                    user_info.role !== "namespaceDeveloper" && (
                      <TabPane
                        className="workspace_table"
                        tab={
                          <span>
                            <FormattedMessage id="workspace_usage_t5" />
                            <Badge className="ml-5" count={(workspaces || []).length} />
                          </span>
                        }
                        key="workspace_usage"
                      >
                        <Table
                          className="cursor-default scroll-x"
                          columns={workspace_column}
                          dataSource={workspaces_list}
                          rowKey={(workspace: workspaces_type_item) => workspace.metadata.labels?.name}
                          pagination={false}
                          onChange={handle_table_change}
                          showSorterTooltip={false}
                        />
                      </TabPane>
                    ),
                    info_key[user_info.role] && (
                      <TabPane
                        className="namespace_table"
                        tab={
                          <span>
                            <FormattedMessage id="namespace_usage_t5" />
                            <Badge className="ml-5" count={namespaces && namespaces.length} />
                          </span>
                        }
                        key="namespace_usage"
                      >
                        <Table
                          className="scroll-x"
                          columns={namespace_column}
                          dataSource={namespaces_list}
                          rowKey={(namespace: namespaces_type_item) => namespace.metadata.name}
                          pagination={false}
                          onChange={handle_table_change}
                          showSorterTooltip={false}
                        />
                      </TabPane>
                    ),
                  ]
                  }
                </Tabs>
                :
                <Modal
                  visible={norole_modal_visible}
                  width={780}
                  footer={null}
                  centered={true}
                  onCancel={() => set_norole_modal_visible(false)}
                  className="norole_modal"
                >
                  <div className="no_role_div">
                    <img src={cry} alt="sorry" />
                    <span className="px-20"><FormattedMessage id="sorry_no_resource_permission" /></span>
                  </div>
                </Modal>
            }

          </Col>
        </Row>
      </Col>
    </TableListModalContext.Provider>
  );
};

export default injectIntl(Global);
